import "./ManageStream.scss";

import React, { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { CampaignContext } from "../../contexts/CampaignContext";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import {pauseBotRoute, updateFeatureVarsRoute,twitchStreamerExistsRoute, startLiveStreamRoute, getCampaignOverviewRoute, checkBotStatusRoute, deactivateStreamRoute, activateStreamRoute, sendBotChatMessageRoute, streamConnectionStatusRoute, getChatHistoryRoute, getFeatureVarsRoute, getStreamCustomisationVarsRoute, changeStreamStatusRoute, stopStreamAnalyticsRoute, getQuizzesByIdsRoute, getCampaignThemesRoute } from "../../api/routes";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import { IconJsxer } from "../../helpers/IconHelper";
import TabbedPanel from "../../components/TabbedPanel/TabbedPanel";
import BotsOverview from "../Campaigns/BotsOverview";
import HMSTimeField from "../../components/forms/HMSTimeField/HMSTimeField";
import Toggle from "../../components/forms/Toggle/Toggle";
import RadioButtonGroup from "../../components/forms/RadioButtonGroup/RadioButtonGroup";
import ConnectingPopup from "./ConnectingPopup";
import ControlBar from "./ControlBar";
import { io } from "socket.io-client";
import ChatTranscript from "./ChatTranscript";
import StreamTranscriptItem from "../../components/Streams/StreamTranscriptItem";
import CirclePerc from "../../components/CirclePerc/CirclePerc";
import HeadedPanel from "../../components/HeadedPanel/HeadedPanel";
import TabStreamManager from "./TabStreamManager";
import TabBots from "./TabBots";
import TabAnalytics from './TabAnalytics';
import { CSL_DASHBOARD_VAR_MAP, CUSTOMISED_URL_MAP, checkAndUpdateObjectVar, findObjectVarLoc, getValFromObject } from "../../config/FeatureDashboardVarMap";
import FeatureControls from "../../components/FeatureControls/FeatureControls";
import TabDisruptors from "./TabDisruptors";
import { POST_MESSAGE_IN_TYPES, POST_MESSAGE_OUT_TYPES, resetOnLoadDefaultFeatureVars } from "../../helpers/FeatureControlsHelper";
import FeaturePreview, { postMessageToPreviewFrame } from "../../components/FeaturePreview/FeaturePreview";
import FeatureChainHeaderControls from "../../components/FeatureChainHeaderControls/FeatureChainHeaderControls";
import FeatureChainStepHeader from "../../components/FeatureChainStepHeader/FeatureChainStepHeader";
import StartupWizard from "./StartupWizard/StartupWizard";
import TabbedInviteUser from "../../components/InviteUserPopup/TabbedInviteUser";
import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";
import { TopBarContext } from "../../contexts/TopBarContext";
import StreamsDropdown from "../../components/StreamsDropdown/StreamsDropdown";
import AnalyticsDropdown from "../../components/AnalyticsDropdown/AnalyticsDropdown";

import FeatureIcon from '../../assets/streamtop/feature_streamtop_icon.svg';
import ConnectIcon from '../../assets/streamtop/connect_streamtop_icon.svg';
import BotIcon from '../../assets/streamtop/bot_streamtop_icon.svg';
import AudioIcon from '../../assets/streamtop/audio_streamtop_icon.svg';
import LeftColorBlockBox, { LEFT_COLOR_BLOCK_STYLES } from "../../components/LeftColorBlockBox/LeftColorBlockBox";
import LeftColorBlockHeadedPanel from "../../components/LeftColorBlockBox/LeftColorBlockHeadedPanel";
import ForceStopPopup from "./ForceStopPopup";
import RateStreamPopup from "./RateStreamPopup/RateStreamPopup";
import {CHANNEL_COLOURS } from "../../helpers/AnalyticsFunctions";
import KillFeaturesPopup from "./KillFeaturesPopup";
import RestrictedCustomisationPopup from "../CustomiseFeature/RestrictedCustomisationPopup";
import CollapsibleHeadedSection from "../../components/CollapsibleHeadedSection/CollapsibleHeadedSection";
import { deriveChainId, chainContainsFeature } from "../../helpers/CampaignsHelper";
import { CHAINS_HELPER } from "../../helpers/ChainsHelper";
import { LIVE_AUDIO_PREVIEW } from "../../helpers/LivePreviews";
import { getFeatureAssetBaseUrl } from "../../helpers/FeatureAssets";
import { getStreamChannelId, getStreamChannelLabel, getStreamChannelProfilePic } from "../../helpers/StreamChannels";
import config from "../../config";
import EXPEDITION_LIVE_STATE from "../../components/FeatureControls/custom-control-components/expedition/ExpeditionLiveState";
import { getIconCategoryColor } from "../../components/common/iconCategory";
import { getPreviewCustomisationVars } from "../../components/v2/CustomisationWorkspace/v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";

window.testIOSocket = (URI) => {
    let socket = io(URI)
    console.log(socket)
}
const ManageStream = (props) => {
    const [showWizard, setShowWizard] = useState(false);
    const closeWizard = () => setShowWizard(false);
    const isEndingStream = useRef(false);

    const [expeditionDataFetched, setExpeditionDataFetched] = useState(false);

    const [showInviteUserPanel, setShowInviteUserPanel] = useState(null);
    const showInvitePanel = (e) => {
        setShowInviteUserPanel(true);
    }
    const closeInviteUserPanel = (e) => {
        setShowInviteUserPanel(false);
    }

    // TopBar dropdown state
    const [showStreamsDropdown, setShowStreamsDropdown] = useState(false);
    const [showAnalyticsDropdown, setShowAnalyticsDropdown] = useState(false);
    const [showTopBarInvitePanel, setShowTopBarInvitePanel] = useState(false);

    const { campaignId, streamId } = useParams();
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    const [, setTopBarContext] = useContext(TopBarContext);

    useEffect(() => {
        setTopBarContext(prev => ({
            ...prev,
            campaignName: campaignContext.campaignData?.campaignName,
            onStreamsClick: () => {
                setShowAnalyticsDropdown(false);
                setShowTopBarInvitePanel(false);
                setShowStreamsDropdown(s => !s);
            },
            onAnalyticsClick: () => {
                setShowStreamsDropdown(false);
                setShowTopBarInvitePanel(false);
                setShowAnalyticsDropdown(s => !s);
            },
            onAddUsersClick: () => {
                setShowStreamsDropdown(false);
                setShowAnalyticsDropdown(false);
                setShowTopBarInvitePanel(true);
            },
            closeAllPopups: () => {
                setShowStreamsDropdown(false);
                setShowAnalyticsDropdown(false);
                setShowTopBarInvitePanel(false);
            },
        }));
    }, [campaignContext.campaignData]); // eslint-disable-line react-hooks/exhaustive-deps

    const campaignData_ref = useRef(null);
    const [streamData, setStreamData] = useState(null);
    const [currentTab, setCurrentTab] = useState(0);
    const [activationObj, setActivationObj] = useState({});
    const [analyticsObj, setAnalyticsObj] = useState({});
    const [timedBots, setTimedBots] = useState({});
    const [intialised, setInitialised] = useState(false);

    // --- Tab1 (Campaign Flows) localStorage persistence ---
    const tab1StorageKey = `ms_tab1_state_${streamId}`;
    const getTab1State = () => {
        try { return JSON.parse(localStorage.getItem(tab1StorageKey) || '{}'); }
        catch (e) { return {}; }
    };
    const saveTab1State = (updates) => {
        try { localStorage.setItem(tab1StorageKey, JSON.stringify({ ...getTab1State(), ...updates })); }
        catch (e) {}
    };
    // null = not yet initialised (defaults to first chain open); array = explicit set
    const [expandedChainIds, setExpandedChainIds] = useState(() => {
        try {
            const s = localStorage.getItem(`ms_tab1_state_${streamId}`);
            const parsed = s ? JSON.parse(s) : null;
            return parsed?.expandedChainIds ?? null;
        } catch (e) { return null; }
    });
    const onChainToggle = useCallback((chainId, isExpanded) => {
        setExpandedChainIds(prev => {
            const current = prev ?? [];
            const newSet = isExpanded
                ? [...new Set([...current, chainId])]
                : current.filter(id => id !== chainId);
            saveTab1State({ expandedChainIds: newSet });
            return newSet;
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const [connecting, setConnecting] = useState(false);
    const [chatConnected, setChatConnected] = useState(false);
    const analyticsAvailable = useRef(false);
    const [botAuthorised, setBotAuthorised] = useState(false);
    const [streamerExists,setStreamerExists] = useState(false);
    const [featureReady, setFeatureReady] = useState(false);
    const [activatedFeatures, setActivatedFeatures] = useState(0);
    const activeFeatureIds = useRef([]);
    const masterFeatureId = useRef(0);

    const [audioEnabled, setAudioEnabled] = useState(false);
    const [streamStarted, setStreamStarted] = useState(false);
    const streamStartedRef = useRef(false);
    const [streamLiveTime, setStreamLiveTime] = useState(null);

    const [demoMode, setDemoMode] = useState(false);
    const [streamStartCountdown, setStreamStartCountdown] = useState(false);
    const [countdownTime, setCountdownTime] = useState(10);
    const [autoHideAfterCountdown, setAutoHideAfterCountdown] = useState(false);
    const [adBug, setAdBug] = useState(false);
    const adBugPosOptions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
    const [adBugPos, setAdBugPos] = useState(adBugPosOptions[0]);
    const [overlayState, setOverlayState] = useState('idle');

    const [currentFeature, setCurrentFeature] = useState(null);
    const currentFeatureRef = useRef(null);
    const changeFeature = (f) => {
        currentFeatureRef.current = f;
        setCurrentFeature(f);
        saveTab1State({ selectedFeatureId: f?._id ?? null });
    }

    // Auto-select feature on load: restore from localStorage, or default to first in first chain
    useEffect(() => {
        if (currentFeatureRef.current) return;
        const chains = campaignContext.campaignData?.chains;
        const features = campaignContext.campaignData?.features;
        if (!chains || chains.length === 0) return;
        if (!features || features.length === 0) return;

        // Try to restore saved feature
        const saved = getTab1State();
        if (saved.selectedFeatureId) {
            const featureData = features.find(f => f._id === saved.selectedFeatureId);
            if (featureData) {
                changeFeature(featureData);
                return;
            }
        }

        // Default: first feature in first chain
        const firstChain = chains[0];
        if (!firstChain || firstChain.length === 0) return;
        const firstItem = firstChain[0];
        const featureId = typeof firstItem === 'string' ? firstItem.split(':')[0] : firstItem?.featureId;
        if (!featureId) return;
        const featureData = features.find(f => f._id === featureId);
        if (featureData) changeFeature(featureData);
    }, [campaignContext.campaignData?.chains?.length ?? 0, campaignContext.campaignData?.features?.length ?? 0]); // eslint-disable-line react-hooks/exhaustive-deps

    const [previewMode, setPreviewMode] = useState(false);
    const previewModeRef = useRef(false);

    // Keep a ref in sync with streamStarted to avoid stale closures in socket handlers
    useEffect(() => {
        streamStartedRef.current = streamStarted;
    }, [streamStarted]);

    // Auto-hide the startup wizard once the stream is live
    useEffect(() => {
        if (chatConnected) {
            setShowWizard(false);
        }
    }, [chatConnected]);
    const [previewLoaded, setPreviewLoaded] = useState(false);
    const [previewTitlePostFix, setPreviewTitlePostFix] = useState('');
    const togglePreviewMode = (newVal, featureToPreview, titlePostFix = '') => {
        if (featureToPreview) {
            changeFeature(featureToPreview);
        } else {
            newVal = false;
        }
        setPreviewTitlePostFix(titlePostFix);
        setPreviewLoaded(false);
        setPreviewMode(newVal);
        previewModeRef.current = newVal;
    }

    const buildCslStateObject = () => {
        return {
            adBug,
            adBugPos,
            streamStartCountdown,
            countdownTime,
            autoHideAfterCountdown,
            overlayState,
        }
    }

    const setCslStateFromSettingsObject = (settingsObject) => {
        const _adBug = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'adBug'));
        if (_adBug !== null) setAdBug(_adBug);
        const _adBugPos = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'adBugPos'));
        if (_adBugPos !== null) setAdBugPos(_adBugPos);
        const _streamStartCountdown = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'streamStartCountdown'));
        if (_streamStartCountdown !== null) setStreamStartCountdown(_streamStartCountdown);
        const _countdownTime = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'countdownTime'));
        if (_countdownTime !== null) setCountdownTime(_countdownTime);
        const _autoHideAfterCountdown = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'autoHideAfterCountdown'));
        if (_autoHideAfterCountdown !== null) setAutoHideAfterCountdown(_autoHideAfterCountdown);
        const _overlayState = getValFromObject(settingsObject, CSL_DASHBOARD_VAR_MAP.rootProp, findObjectVarLoc(CSL_DASHBOARD_VAR_MAP, 'overlayState'));
        if (_overlayState !== null) setOverlayState(_overlayState);
    }

    const [liveStreamServerState, setLiveStreamServerState] = useState(null);
    const toggleChatCommandEnabled = (featureId) => {
        if (chatConnected && socket.current) {
            if (liveStreamServerState?.disabledChatCommandFeatureIds?.indexOf(featureId) === -1 ?? true) {
                // Disable
                socket.current.emit('disableFeatureChatCommands', {streamID:streamId, featureId:featureId});
            } else {
                // Enable
                socket.current.emit('enableFeatureChatCommands', {streamID:streamId, featureId:featureId});
            }
        }
    }

    // Capture changes and send them up to the backend, but only once initialised...
    useEffect(
        () => {
            if (intialised) {
                
                console.log('Something changed - send up to the backend!', socket.current);
                if (socket.current) {
                    
                    const cslState = buildCslStateObject();
                    let varsUpdated = false;
                    for (let i = 0; i < CSL_DASHBOARD_VAR_MAP.vars.length; i++) {
                        const updated = checkAndUpdateObjectVar(featureVarsRef.current.current, CSL_DASHBOARD_VAR_MAP.rootProp, CSL_DASHBOARD_VAR_MAP.vars[i].objectVar, cslState[CSL_DASHBOARD_VAR_MAP.vars[i].stateVar], CSL_DASHBOARD_VAR_MAP.vars[i].varType);
                        if (updated) varsUpdated = true;
                    }

                    // Some root level vars
                    if (featureVarsRef.current.current.demoMode !== demoMode) {
                        featureVarsRef.current.current.demoMode = demoMode;
                        varsUpdated = true;
                    }
                    if (featureVarsRef.current.current.activated !== streamStarted) {
                        featureVarsRef.current.current.activated = streamStarted;
                        varsUpdated = true;
                    }

                    console.log('Vars updated: ', varsUpdated);
                    if (varsUpdated) {
                        setFeatureVars(featureVarsRef.current);
                        reportFeatureVarsChanged();
                    }
                }
            } else {
                console.log('Don\'t send any changes yet! Still initialising...');
            }
        },
        [
            demoMode,
            streamStarted,
            streamStartCountdown,
            countdownTime,
            autoHideAfterCountdown,
            adBug,
            adBugPos,
            overlayState,
        ]
    )

    // Some things need to be reported contantsly (range sliders).
    // In a live scenario we don't want to do this too often, so we'll throttle it, by only allowing it to happen every 100ms...
    const constantReportingLastUpdateTime = useRef(null);
    const constantReportingTimeout = useRef(null);
    const reportFeatureVarsChanged = (onlyUpdateDisruptor = false, onComplete = null) => {
        // A range slider can trigger an update that is meant just for the disruptor to constantly update the disruptor,
        // but this only really works in preview mode as in live mode we need to send an update to the server to keep all dashboards in sync...
        if (!onlyUpdateDisruptor) {
            // A full update
            clearTimeout(constantReportingTimeout.current);
            // constantReportingTimeout.current = null;
            constantReportingLastUpdateTime.current = Date.now();
            updateFeatureVars(featureVarsRef.current.current, onComplete);
        } else
        if (!previewModeRef.current) {
            // We are not in preview mode, so we need to send the update to the server.
            // Here's where out throttling comes in...
            if (constantReportingLastUpdateTime.current === null || Date.now() - constantReportingLastUpdateTime.current > 100) {
                clearTimeout(constantReportingTimeout.current);
                // constantReportingTimeout.current = null;
                constantReportingLastUpdateTime.current = Date.now();
                updateFeatureVars(featureVarsRef.current.current, onComplete);
            } else {
                // Also protecting this by checking if the timeout is null, we will null it only when the server responds, 
                // so we can be duble sure not to overload the server with requests...
                if (constantReportingTimeout.current === null) {
                    constantReportingTimeout.current = setTimeout(() => {
                        updateFeatureVars(featureVarsRef.current.current, onComplete);
                        // constantReportingTimeout.current = null;
                    }, 100);
                }
            }
        }
        if (previewModeRef.current === true) {
            // In preview mode, we can send the data straight to the preview frame
            console.log('Report vars to preview: ', featureVarsRef.current.current[currentFeatureRef.current._id]);
            postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.SETTINGS_VARS_RECEIVED, featureVarsRef.current.current[currentFeatureRef.current._id]);
        }
    }

    const reportCustomisationVarsChanged = (updatedVars, featureID) => {
        console.log('EMIT CUSTOMISATION CHANGES', updatedVars, featureID, socket);
       socket.current.emit('updateCustomisationVars', {streamID:streamId, updatedVars:updatedVars, featureID:featureID});
       console.log('EMITTED')
        if (previewModeRef.current === true) {
            postMessageToPreviewFrame(
                POST_MESSAGE_OUT_TYPES.CUSTOMISATION_VARS_RECEIVED,
                getPreviewCustomisationVars(currentFeatureRef.current, featureID, campaignId, updatedVars.current[featureID])
            );
        }
    }

    const reportCustomisationVarsChangedAndSave = (updatedVars, featureID, reportToFeature = true) => {
        console.log('EMIT CUSTOMISATION CHANGES', updatedVars, featureID, socket);
       socket.current.emit('updateCustomisationVarsWithSave', {campaignID:campaignId, streamID:streamId, updatedVars:updatedVars, featureID:featureID, reportToFeature: reportToFeature});
       console.log('EMITTED')
        if (previewModeRef.current === true) {
            postMessageToPreviewFrame(
                POST_MESSAGE_OUT_TYPES.CUSTOMISATION_VARS_RECEIVED,
                getPreviewCustomisationVars(currentFeatureRef.current, featureID, campaignId, updatedVars.current[featureID])
            );
        }
    }

    const MAX_CHAT_MESSAGES = 250;
    // Doing this seems to work, hopefully I can limit the length of the chat history this way...
    let _chatHistory = [];
    const [chatHistory, setChatHistory] = useState(_chatHistory);

    const [showingTooltip, setShowingTooltip] = useState(false);
    const [tooltipText, setTooltipText] = useState('');
    const [tooltipPos, setTooltipPos] = useState({left: 0, bottom: 0});
    const tooltipTimeout = useRef(null);
    const showTooltip = (text, e) => {
        setTooltipPosToMouse(e, true);
        setTooltipText(text);
        if (text.length > 0 && !showingTooltip && tooltipTimeout.current === null) {
            tooltipTimeout.current = setTimeout(() => setShowingTooltip(true), 300);
        }
    }
    const hideTooltip = (e) => {
        clearTimeout(tooltipTimeout.current);
        tooltipTimeout.current = null;
        setShowingTooltip(false);
    }
    const setTooltipPosToMouse = (e, force = false) => {
        if (showingTooltip || force) {
            const toolTipPos = {
                left: e.pageX + 'px',
                bottom: (window.innerHeight - e.pageY + 10) + 'px'
            }
            setTooltipPos(toolTipPos);
        }
    }

    //Connect to the web socket server to receive real time updates created by other users and chat
    const socket = useRef(null);
    const [socketState, setSocketState] = useState(null);
    const createNewSocketConnection = () => {
        if (socket.current === null) {
            const hostedSocketBaseUrl = window.location.hostname === 'dev.campaignstudio.tv'
                || window.location.hostname === 'api-dev.campaignstudio.tv'
                ? 'https://api-dev.campaignstudio.tv'
                : config.socketIoBaseUrl;

            socket.current = process.env.REACT_APP_NODE_ENV == 'local' 
          ? io(process.env.REACT_APP_SOCKET_IO_BASE_URL) 
                    : io(hostedSocketBaseUrl, {
              transports: ['polling'],  // Start with polling only
              upgrade: true,            // Then upgrade to WebSocket
              secure: true,
              path: '/socket.io/',
              reconnectionAttempts: 5,
              reconnectionDelay: 1000,
              timeout: 20000
            });
        
            console.log(socket.current, process.env.REACT_APP_SOCKET_IO_BASE_URL, process.env.REACT_APP_NODE_ENV);
            //socket = io.connect(process.env.REACT_APP_API_BASE_URL)
            console.log(socket.current)
            socket.current.on('connect', () => {
                console.log('JOIN ROOM');
                socket.current.emit('dashboardJoinStream', streamId);

                // Test joining the expedition room...
                // socket.current.emit('dashboardJoinStream', 'EXPEDITION_APP_ROOM');
            })
            // Test receiving expedition app state updates
            /*
            socket.current.on('expeditionUpdateAppState', (data) => {
                console.log('EXPEDITION APP STATE UPDATED', data);
                setTimeout(() => {
                    // Test emitting an update back...
                    console.log('TEST EMIT WAYPOINT REACHED');
                    socket.current.emit('expeditionAppSendCommand', {command: 'wayPointReached', updatedState: EXPEDITION_LIVE_STATE, primary_stream: streamId});
                }, 1000);
            });
            */

            socket.current.on('activatingStream', function (data) {
                console.log('Received activatingStream message from the server!', data);
            });
            socket.current.on('streamActivated', function (data) {
                console.log('STREAM ACTIVATED')
                toast.success(data.message);
                setChatConnected(true);
                // See if the sever has some chain data (ie. we are not the first dashboard to conenct!)
                requestChainDataFromServer();
                requestLiveStreamStateFromServer();
            });
            socket.current.on('streamDeactivated', function (data) {
                toast.success(data.message);
                setChatConnected(false);
            });
            socket.current.on('updateFeatureVars', (newFeatureVars) =>{
                featureVarsRef.current.current = newFeatureVars;
                setCslStateFromSettingsObject(featureVarsRef.current.current);
                setFeatureVars({...featureVarsRef.current});
            })
            socket.current.on('updateCustomisationVars', (data) =>{
                console.log('UPDATE CUSTOMIOSATION VARS SOCKET CALL')
                customisationVars.current = data.updatedVars;
            })
            socket.current.on('activationStatus', (activationData) => {
                setActivationObj(activationData.activationObj);
                setConnecting(activationData.isActivating);
            })
            socket.current.on('chatMessage', (chatObj) => {
                _chatHistory = _chatHistory.concat(chatObj);
                while (_chatHistory.length > MAX_CHAT_MESSAGES) {
                    _chatHistory.shift();
                }
                setChatHistory(_chatHistory);
            })
            socket.current.on('heartbeat', (timeObj) => {
                // console.log('Heartbeat: ', timeObj);
                if (!streamStartedRef.current) return; // ignore heartbeats when stream has been stopped
                setStreamLiveTime(timeObj);
            });
            socket.current.on('updateAnalytics', (minimisedAnalyticsObj) =>{
                setAnalyticsObj((prev) => {
                    return {
                        ...prev,
                        ...minimisedAnalyticsObj,
                    };
                });
            });
            socket.current.on('updateStreamTranscript', (newTranscript) =>{
                setAnalyticsObj((prev) => {
                    const transcript = prev?.transcript ? [...prev.transcript, newTranscript] : [newTranscript];
                    return {
                        ...prev,
                        transcript,
                    };
                });
            });
            socket.current.on('updateTimedBots', (timedBots) =>{
                setTimedBots(timedBots)
                console.log('TB:',timedBots)
                
            });
            
            socket.current.on("connect_error", (err) => {
                console.log(`connect_error due to ${err.message}`);
              });

            // messages from the feature page
            socket.current.on("featureReady", (data) => {
                console.log('***************************** FEATURE READY', data);
                setFeatureReady(true);
                if (activeFeatureIds.current.indexOf(data.featureID) === -1) {
                    activeFeatureIds.current.push(data.featureID);
                    setActivatedFeatures(activeFeatureIds.current.length);
                }
                console.log('Feature list:', activeFeatureIds.current);
            }
            
            );
            socket.current.on("featureUnloaded", 
                (data) => {
                    console.log('***************************** FEATURE UNLOAD', data);
                    if (activeFeatureIds.current.indexOf(data.featureID) !== -1) {
                        activeFeatureIds.current = activeFeatureIds.current.filter((id) => id !== data.featureID);
                        setActivatedFeatures(activeFeatureIds.current.length);
                        if (activeFeatureIds.current.length === 0) {
                            setFeatureReady(false); 
                        }
                    }
                    if (!data.retainAudioState) {
                        setAudioEnabled(false);
                    }
                    console.log('Feature list:', activeFeatureIds.current);
                });

            socket.current.on('setMasterFeature', (data) => {
                // console.log('Heartbeat: ', timeObj);
                console.log('NEW MASTER FEATURE:', data.masterID);
                masterFeatureId.current = data.masterID;
            });

            socket.current.on("audioEnabled", () => {setAudioEnabled(true)});


            socket.current.on('clawError', function (data) {
                toast.error('CLAW MACHINE ERROR ('+data.machineID+') '+data.info);
            });
            socket.current.on('clawMoveEnded', function (data) {
                // The only data passed back is whether or not we won a prize, no target machine id or anything else.
                // There is a long and difficult to follow chain of callbacks being passed around on the backend to change this,
                // so I've opted to do minimal changes to fix this error with the toast message.
                // Mainly because I don't want to introduce bugs that might be hard to test when what we currently have fits our needs 
                // and this toast message is a really minor feature. 
                // If we introduce more machines later, we may need to look at this more closely.
                // (The original line of code to show the toast is commented out below, replaced with a simpler version)
                // - Carl
                // toast.success('CLAW MACHINE ('+data.machineID+') RESULT: '+ data.isWinner ? 'PRIZE WON' : 'LOST');
                toast.success('CLAW MACHINE RESULT: '+ data === true ? 'PRIZE WON' : 'LOST');
            });


            // receiving chain updates, this keeps all dashboards in sync
            // find chainObjects_ref and the flow is documented just above it...
            socket.current.on("chainUpdateDown", (chains) => {
                console.log('Chain update down: ', chains);
                chainUpdateReceived_ref.current = true;
                setChainUpdateReceived(true);
                setChainSkipAllowed(true);
                setForceSkipAllowed(false);

                let serverSentChains = false;
                for (let prop in chains) {
                    // We're doing this in a for in because we don't want to wipe out local chain data with blank data
                    if (prop !== 'rawChainData') {
                        serverSentChains = true;
                        chainObjects_ref.current[prop] = chains[prop];
                        if (chains[prop].active /*&& currentTab === 1*/) {
                            // We are on the chain tab and the chain is active, update the current feature
                            if (chains[prop].index >= 0 && chains[prop].index < chains[prop].chainItems.length) {
                                selectDisruptor(findFeatureData(chains[prop].chainItems[chains[prop].index].featureId));
                            }
                        }
                    }
                }
                const campaignData = campaignData_ref.current || campaignContext.campaignData;
                const shouldRefreshServerChains = isChainMaster.current && serverSentChains && serverChainsNeedRefresh(chains, campaignData);
                setChainObjects({...chainObjects_ref.current});
                if (shouldRefreshServerChains) {
                    console.log('Server chain data is stale, rebuilding from current campaign data');
                    buildAllFeatureChainsAndSendToServer();
                } else if (serverSentChains) {
                    console.log('Server sent chains down!');
                } else {
                    if (isChainMaster.current) {
                        buildAllFeatureChainsAndSendToServer(chains.rawChainData);
                    } else {
                        // If we are not the chain master, request the chain data again after a short delay,
                        // maybe the chain master is still processing the data or something...
                        // Obviously we only need to do this if the campaign data has chains - otherwise we end up in an infinite loop!
                        const campaignData = campaignData_ref.current || campaignContext.campaignData;
                        if (campaignData.chains && campaignData.chains.length > 0) {
                            let gotActualChainData = false;
                            for (let i = 0; i < campaignData.chains.length; i++) {
                                console.log('Check chain before re_request: ', campaignData.chains[i]);
                                if (campaignData.chains[i].length > 0) {
                                    gotActualChainData = true;
                                }
                            }
                            if (gotActualChainData) {
                                setTimeout(() => {
                                    console.log('RE_REQUEST DATA');
                                    requestChainDataFromServer();
                                    requestLiveStreamStateFromServer();
                                }, 5000);
                            }
                        }
                    }
                }
            });

            // Reload all dashboards on a force stop...
            socket.current.on('forceFeatureStop', () => {
                if (isEndingStream.current) {
                    // This dashboard triggered the stop — don't reload, we want the rating popup to stay
                    isEndingStream.current = false;
                    return;
                }
                document.location.reload();
            });

            // Receive persistent server state
            socket.current.on('liveStreamState', (state) => {
                setLiveStreamServerState(state);
            });

            console.log('CREATE SOICKET CONNECTION');
            // See if the sever has some chain data (ie. we are not the first dashboard to conenct!)
            requestChainDataFromServer();
            requestLiveStreamStateFromServer();
        }
    }

    const [showingKillOldFeaturesPopup, setShowingKillOldFeaturesPopup] = useState(false);
    const killOldFeaturePages = () => {
        if (socket.current) {
            if (activeFeatureIds.current.length > 1) {
                let featureIdToKeep = masterFeatureId.current;
                if (featureIdToKeep === 0) {
                    // Feature ID is a timestamp, find the most recent one...
                    let mostRecent = 0;
                    for (let i = 0; i < activeFeatureIds.current.length; i++) {
                        if (activeFeatureIds.current[i] > mostRecent) {
                            mostRecent = activeFeatureIds.current[i];
                        }
                    }
                    featureIdToKeep = mostRecent;
                }
                console.log('Kill old features, keep: ', featureIdToKeep);
                socket.current.emit('killOldFeatures', {streamID: streamId, keepFeatureIDOpen: featureIdToKeep});
            }
        }
    }

    const getChatHistory = () => {
        axios
        .get(getChatHistoryRoute, {
            params: {  streamID:streamId },
            withCredentials:true
        })
        .then(function (response) {
            let newChatHistory = response.data.chatHistory
            // I couldn't find a way to limit the number of chat message doing it this way...
            // setChatHistory((chatHistory) => [...newChatHistory, ...chatHistory])
            // This method works, though
            _chatHistory = newChatHistory.concat(_chatHistory);
            while (_chatHistory.length > MAX_CHAT_MESSAGES) {
                _chatHistory.shift();
            }
            setChatHistory(_chatHistory);
        })
        .catch(function (error) {
            console.log(error)
        });
    }
    useEffect(
        () => {
         
            updateViwerChart();
            updateChattersChart();
        }, [analyticsObj]
    )
    useEffect (() => {
        if(streamData)
            {
            let sortedChannels = streamData.channels.toSorted(function(a, b) {
                var textA = a.twitchHandle.toUpperCase();
                var textB = b.twitchHandle.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            
            });
        setChannelList(sortedChannels);
        }
    }, [streamData])
    const viewersChartOptions = {}
    const [viewerChartConfig, setViewerChartConfig] = useState({});
    const updateViwerChart =() =>{

      
        let formattedViewerObject = [];
        if(analyticsObj.viewerCount)
        {
            for(let i=0; i<analyticsObj.viewerCount.length; i++)
            {
                let viewerObj = analyticsObj.viewerCount[i];
                let newViewerObj = {
                    x: analyticsObj.featureStartTime + viewerObj.timeStamp,
                    y: viewerObj.viewers
                }
                formattedViewerObject.push(newViewerObj)
            }
        }
        setViewerChartConfig( {
            
            data: {
              datasets: [{
                data:formattedViewerObject
              }]
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'minute'
                        }
                    }
                }
            }
          })
    }
    const [chattersChartData, setChattersChartData] = useState({ labels: [], datasets: []})
    const updateChattersChart = () =>{

        if(analyticsObj.userList)
        {
            setChattersChartData({
                labels: ['Messages', 'Unique Chatters'],
                datasets: [
                {
                   
                    data: [analyticsObj.messages,analyticsObj.userList.length],
                    backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    
                    ],
                    borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                
                    ],
                    borderWidth: 1,
                }
                ]
            });
        }
    }

    const navigate = useNavigate();

    const customisationVars = useRef(null);
    const getCustomisationVars = () => {
        console.log('Get Customisation Vars');
        axios
        .get(getStreamCustomisationVarsRoute, {
            params: { campaignID: campaignId, streamID: streamId },
            withCredentials:true
        })
        .then(function (response) {
            if (response.data.customisationVars) {
                customisationVars.current = response.data.customisationVars;
                console.log('Got customisationVars: ', customisationVars.current);
                // getFeatureVars();
                getThemeData();
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
        });
    }

    /* THEMES */
    const [themeData, setThemeData] = useState(null);
    const themeDataRef = useRef(null);
    const themeDataFetchedRef = useRef(false);

    const getThemeData = () => {
        axios
            .get(getCampaignThemesRoute, { params: { campaignID: campaignId }, withCredentials: true })
            .then((res) => {
                console.log('[THEMES] --- Got theme data: ', res.data);
                themeDataRef.current = res.data.themes;
                setThemeData(res.data.themes);

                themeDataFetchedRef.current = true;
                getFeatureVars();
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
            });
    }

    const applyThemeToFeature = (featureId, themeId) => {
        console.log('Apply theme to feature: ', featureId);
        if (socket.current) {
            socket.current.emit('refreshFeature', {streamID: streamId, featureID: featureId, applyTheme: themeId});
        }
    }

    const [featureVars, setFeatureVars] = useState({});
    const featureVarsRef = useRef(null);
    const getFeatureVars = () => {
        console.log('Get Feature Vars');
        axios
        .get(getFeatureVarsRoute, {
            params: { campaignID: campaignId, streamID: streamId, includeBotData:true },
            withCredentials:true
        })
        .then(function (response) {
            console.log('STREAM VARS',response.data);
            if (response.data.streamVars) {
                featureVarsRef.current = response.data.streamVars;

                // Set default theme data if it doesn't exist
                for (let p in featureVarsRef.current.current) {
                    if (typeof featureVarsRef.current.current[p] === 'object') {
                        if (typeof featureVarsRef.current.current[p].theme === 'undefined') {
                            featureVarsRef.current.current[p].theme = {id: ''};
                        }
                    }
                }

                setCslStateFromSettingsObject(featureVarsRef.current.current);
                setFeatureVars(featureVarsRef.current);
                setStreamStarted(featureVarsRef.current.current.activated);
                if (featureVarsRef.current.current.activated) {
                    analyticsAvailable.current = true;
                }
                setTimedBots(response.data.timedBots)
                getQuizData();

                resetOnLoadDefaultFeatureVarsInternal();
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
            // console.log(error.response)
        });
    }
    const resetOnLoadDefaultFeatureVarsInternal = () => {
        // Reset any featureVars that need to be reset on load...
        const campaignData = campaignData_ref.current || campaignContext.campaignData;
        // console.log('RESET ONLOAD VARS 1: ', campaignData.features, campaignData.features.length);
        if (campaignData && campaignData.features) {
            for (let i = 0; i < campaignData.features.length; i++) {
                // console.log('RESET ONLOAD VARS: ', campaignData.features[i]);
                let madeChanges = resetOnLoadDefaultFeatureVars(featureVarsRef.current, campaignData.features[i], customisationVars.current);
            }
        } else {
            setTimeout(() => resetOnLoadDefaultFeatureVarsInternal(), 20);
        }
    }
    const updateFeatureVars = (updatedVars, onComplete = null) => {
        axios
        .post(updateFeatureVarsRoute, {
            campaignID: campaignId, 
            streamID: streamId, 
            updatedVars,
            withCredentials:true
        })
        .then(function (response) {
            console.log(response.data);
            // featureVars.current = response.data.streamVars;
            // setInitialised(true);
            constantReportingTimeout.current = null;
            if (onComplete) {
                onComplete(response.data)
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
            // console.log(error.response)
            constantReportingTimeout.current = null;
        });
    }

    const quizData_ref = useRef(null);
    const getQuizData = () => {
        console.log('Get quiz data: ', customisationVars.current);

        const quizIds = [];
        const quizIdsByDisruptorId = {};
        for (let prop in customisationVars.current.current) {
            if (customisationVars.current.current[prop].quizdata) {
                console.log('Found quiz data (' + prop + '): ', customisationVars.current.current[prop].quizdata.quizdata.quizzes);
                quizIdsByDisruptorId[prop] = [];
                for (let i = 0; i < customisationVars.current.current[prop].quizdata.quizdata.quizzes.length; i++) {
                    if (customisationVars.current.current[prop].quizdata.quizdata.quizzes[i].quizID && customisationVars.current.current[prop].quizdata.quizdata.quizzes[i].quizID !== '') {
                        quizIds.push(customisationVars.current.current[prop].quizdata.quizdata.quizzes[i].quizID.quiz._id);
                        quizIdsByDisruptorId[prop].push(customisationVars.current.current[prop].quizdata.quizdata.quizzes[i].quizID.quiz._id);
                    }
                }
            }
        }
        if (quizIds.length > 0) {
            console.log('Get quiz data for ids: ', quizIds);
            axios.get(getQuizzesByIdsRoute, {params: {ids: quizIds}}).then(
                (res) => {
                    console.log('Got quiz data: ', res.data.quizzes);
                    quizData_ref.current = {};
                    for (let prop in quizIdsByDisruptorId) {
                        quizData_ref.current[prop] = {quizzes: []};
                        for (let i = 0; i < quizIdsByDisruptorId[prop].length; i++) {
                            for (let j = 0; j < res.data.quizzes.length; j++) {
                                if (quizIdsByDisruptorId[prop][i] === res.data.quizzes[j]._id) {
                                    quizData_ref.current[prop].quizzes.push(res.data.quizzes[j]);
                                    break;
                                }
                            }
                        }
                    }
                    console.log('Quiz data ref: ', quizData_ref.current);
                    setInitialised(true);
                }
            ).catch(
                (err) => {
                    console.log('Error getting quiz data: ', err);
                }
            )
        } else {
            // No quizzes!
            setInitialised(true);
        }
    }

    // Special functions that can be triggered by buttons in the feature controls in place of the normal feature commands...
    const BUTTON_FUNCTIONS = {
        reportFeatureVarsChanged: (featureId, param) => reportFeatureVarsChanged(),
        startLivePoll: (featureId, param) => {
            reportFeatureVarsChanged(false, 
                () =>
                    setTimeout(() => {
                        sendFeatureCommand(null, 'START_POLL', featureId, param);
                        // postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED, { command: 'START_POLL', extraData: {username:'CampaignStudio', hashtag:'Manual Press', commandParam: param} })
                    }, 100)
            );
        },
        createNewLivePoll: (featureId, param) => {
            openRestrictedCustomisationPopup(featureId, "Edit Live Polls", "setup", "pollData", "polls");
        },
        editRandomizerOptions: (featureId, param) => {
            openRestrictedCustomisationPopup(featureId, "Edit Randomizer Options", "setup", "options" + param, "options");
        },
        editLiveTextPresets: (featureId, param) => {
            openRestrictedCustomisationPopup(featureId, "Edit Live Text Presets", "setup", "presetText", "presets");
        },
        saveLiveTextPreset: (featureId, param) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            const presetDataToSave = {
                presetName: _featureVars.liveTextControls.presetName,
                headerText: _featureVars.liveTextControls.headerText,
                mainContent: _featureVars.liveTextControls.mainContent
            }
            if (presetDataToSave.mainContent === '') {
                toast.error('Cannot save an empty preset!');
                return;
            }
            if (presetDataToSave.presetName === '') {
                toast.error('Please enter a name for the preset!');
                return;
            }
            if (presetDataToSave.headerText === '') {
                toast.error('Please enter a header for the preset!');
                return;
            }
            let checkForExisting = _customisationVars.setup.presetText.presets.findIndex((p) => p.presetName === presetDataToSave.presetName);
            let presetNameExists = checkForExisting !== -1;
            let presetSuffix = 1;
            while (presetNameExists) {
                const newPresetName = presetDataToSave.presetName + ' (' + (presetSuffix++) + ')'; 
                checkForExisting = _customisationVars.setup.presetText.presets.findIndex((p) => p.presetName === newPresetName);
                if (checkForExisting === -1) {
                    presetDataToSave.presetName = newPresetName;
                    presetNameExists = false;
                }
            }
            _customisationVars.setup.presetText.presets.push(presetDataToSave);
            reportCustomisationVarsChangedAndSave(customisationVars.current, featureId, false);
            toast.success('Preset Text saved!');
        },
        saveResponseLiveTextPreset: (featureId, param) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            const presetDataToSave = {
                presetName: _featureVars.responseTextControls.presetName,
                headerText: _featureVars.responseTextControls.headerText,
                mainContent: _featureVars.responseTextControls.mainContent
            }
            if (presetDataToSave.mainContent === '') {
                toast.error('Cannot save an empty preset!');
                return;
            }
            if (presetDataToSave.presetName === '') {
                toast.error('Please enter a name for the preset!');
                return;
            }
            if (presetDataToSave.headerText === '') {
                toast.error('Please enter a header for the preset!');
                return;
            }
            let checkForExisting = _customisationVars.setup.presetText.presets.findIndex((p) => p.presetName === presetDataToSave.presetName);
            let presetNameExists = checkForExisting !== -1;
            let presetSuffix = 1;
            while (presetNameExists) {
                const newPresetName = presetDataToSave.presetName + ' (' + (presetSuffix++) + ')'; 
                checkForExisting = _customisationVars.setup.presetText.presets.findIndex((p) => p.presetName === newPresetName);
                if (checkForExisting === -1) {
                    presetDataToSave.presetName = newPresetName;
                    presetNameExists = false;
                }
            }
            _customisationVars.setup.presetText.presets.push(presetDataToSave);
            reportCustomisationVarsChangedAndSave(customisationVars.current, featureId);
            toast.success('Response preset saved!');
        },
        selectLiveTextPreset: (featureId, param) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            console.log('Select live text preset: ', featureId, _featureVars, _customisationVars);

            const presetTextIndex = Number(_featureVars.liveTextControls.presetText);
            const presetTextData = _customisationVars.setup.presetText.presets[presetTextIndex];
            if (presetTextData) {
                _featureVars.liveTextControls.presetName = presetTextData.presetName;
                _featureVars.liveTextControls.headerText = presetTextData.headerText;
                _featureVars.liveTextControls.mainContent = presetTextData.mainContent;
                featureVarsRef.current = {current: {...featureVarsRef.current.current, [featureId]: _featureVars}};
                setFeatureVars(featureVarsRef.current);
                reportFeatureVarsChanged();
            }
        },
        selectResponseLiveTextPreset: (featureId, param) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            console.log('Select live text preset: ', featureId, _featureVars, _customisationVars);

            const presetTextIndex = Number(_featureVars.responseTextControls.presetText);
            const presetTextData = _customisationVars.setup.presetText.presets[presetTextIndex];
            if (presetTextData) {
                _featureVars.responseTextControls.presetName = presetTextData.presetName;
                _featureVars.responseTextControls.headerText = presetTextData.headerText;
                _featureVars.responseTextControls.mainContent = presetTextData.mainContent;
                featureVarsRef.current = {current: {...featureVarsRef.current.current, [featureId]: _featureVars}};
                setFeatureVars(featureVarsRef.current);
                reportFeatureVarsChanged();
            }
        },
        previewAudio: (featureId, param, frameId) => {
            // console.log('Preview audio: ', featureId, param);
            const resolveAudioPreviewData = (candidate) => {
                if (!candidate || typeof candidate !== 'object') {
                    return { srcUrl: null, filename: null, isDefault: false, isStreamLevel: false };
                }

                const normaliseFileField = (fileField, fallbackMeta = {}) => {
                    if (!fileField) {
                        return {
                            srcUrl: fallbackMeta.srcUrl || null,
                            filename: fallbackMeta.filename || null,
                            isDefault: Boolean(fallbackMeta.isDefault),
                            isStreamLevel: Boolean(fallbackMeta.isStreamLevel),
                        };
                    }

                    if (typeof fileField === 'string') {
                        return {
                            srcUrl: fallbackMeta.srcUrl || null,
                            filename: fileField,
                            isDefault: Boolean(fallbackMeta.isDefault),
                            isStreamLevel: Boolean(fallbackMeta.isStreamLevel),
                        };
                    }

                    if (typeof fileField === 'object') {
                        return {
                            srcUrl: fileField.srcUrl || fallbackMeta.srcUrl || null,
                            filename: fileField.filename || fallbackMeta.filename || null,
                            isDefault: Boolean(fileField.isDefault ?? fallbackMeta.isDefault),
                            isStreamLevel: Boolean(fileField.isStreamLevel ?? fallbackMeta.isStreamLevel),
                        };
                    }

                    return { srcUrl: null, filename: null, isDefault: false, isStreamLevel: false };
                };

                if (candidate.srcUrl || candidate.filename) {
                    return normaliseFileField(candidate.filename, candidate);
                }

                for (const key in candidate) {
                    const value = candidate[key];
                    if (value && typeof value === 'object' && (value.srcUrl || value.filename)) {
                        return normaliseFileField(value.filename, value);
                    }
                }

                return { srcUrl: null, filename: null, isDefault: false, isStreamLevel: false };
            };

            let { srcUrl, filename, isDefault, isStreamLevel } = resolveAudioPreviewData(param);
            if (srcUrl === null) {
                // console.log('No srcUrl found in param object: ', param);
                // We need to build the srcUrl!
                if (filename === null) {
                    console.log('No filename found in param object: ', param);
                    return;
                }
                // Everything we need is in the param object, except the campaignId
                const campaignId = campaignContext.campaignData._id;
                // Build the srcUrl
                srcUrl =
                    (isDefault ? getFeatureAssetBaseUrl(true) + findFeatureData(featureId).feature.defaultAssetFolder : getFeatureAssetBaseUrl(false) + 'campaigns/' + campaignId)
                    + '/' + CUSTOMISED_URL_MAP['audio'].dir + '/' + filename;
                // console.log('Built srcUrl: ', srcUrl);
            }
            LIVE_AUDIO_PREVIEW.playStopAudio(srcUrl);
        },
    }
    const sendFeatureCommand = (e, commandString, featureId, param = null, forcePreviewControlsId = null) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        const previewTargetId = forcePreviewControlsId || currentFeatureRef.current?._id;
        if (previewModeRef.current === true && previewTargetId) {
            // We are previewing this feature, redirect the command to the requested preview frame.
            if (previewLoaded) {
                if (BUTTON_FUNCTIONS[commandString]) {
                    console.log('Running button function: ', commandString, featureId, param);
                    BUTTON_FUNCTIONS[commandString](featureId, param);
                } else {
                    postMessageToPreviewFrame(
                        POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED,
                        { command: commandString, extraData: {username:'CampaignStudio', hashtag:'Manual Press', commandParam: param} },
                        previewTargetId
                    );
                }
            }
        } else {
            if (BUTTON_FUNCTIONS[commandString]) {
                console.log('Running button function: ', commandString, featureId, param);
                BUTTON_FUNCTIONS[commandString](featureId, param);
            } else {
                console.log('Emitting feature command: ', commandString, featureId, param);
                socket.current.emit('featureCommand', {streamID:streamId, featureID: featureId, command:commandString, extraData:{username:'CampaignStudio', hashtag:'Manual Press', commandParam: param}});
            }
        }
    }

    const findStream = (campaignData = null) => {
        campaignData = campaignData || campaignContext.campaignData;
        console.log('Campaign Data: ', campaignData);
        for (let i = 0; i < campaignData.streams.length; i++) {
            if (campaignData.streams[i]._id === streamId) {
                setStreamData(campaignData.streams[i]);
                console.log('Stream Data: ', campaignData.streams[i])
                // Set initial settings here?
                checkConnectionStatus(campaignData.streams[i]._id);
                checkBotStatus(campaignData.streams[i].twitchHandle);
                checkStreamerStatus(campaignData.streams[i].twitchHandle)
                createNewSocketConnection();
                getChatHistory();

                // Final call before we can do anything is to pull in the feature vars...
                // getFeatureVars();
                getCustomisationVars();
                break;
            }
        }
    }
    const deactivateChat = (e) => {
        e.preventDefault();
   
        for(let i=0; i<streamData.channels.length; i++)
        {
            console.log(streamData.channels[i].twitchHandle)
            axios
            .post(deactivateStreamRoute, {
                streamID:streamId,
                campaignID:campaignId,
                channel:streamData.channels[i].twitchHandle,
                withCredentials:true
            })
            .then(function (response) {
                console.log(response.data)
                //toast.success(response.data.message);
                setChatConnected(false);
                setStreamStarted(false);
                setStreamLiveTime(null);
                /* if (socket.current) {
                    socket.current.close();
                }
                socket.current = null; */
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
                // console.log(error.response)
            });



        }
            if(streamData.twitchHandle)
            {
            axios
            .post(deactivateStreamRoute, {
                streamID:streamId,
                campaignID:campaignId,
                channel:streamData.twitchHandle,
                withCredentials:true
            })
            .then(function (response) {
                console.log(response.data)
                //toast.success(response.data.message);
                setChatConnected(false);
                setStreamStarted(false);
                setStreamLiveTime(null);
                /* if (socket.current) {
                    socket.current.close();
                }
                socket.current = null; */
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
                // console.log(error.response)
            });
        }

    }

    const activateChat = (e) => {
        e.preventDefault();
        if (!streamData?.channels?.length) {
            toast.error('Add at least one channel to this stream before connecting.');
            return;
        }
        // setActivationObj({stage: 1, botAuthorised: false, socketCreated: false, twitchConnected: false});
        setConnecting(true);
        console.log('CAMPAIGN CONTEXT', campaignContext)
        isChainMaster.current = true;
        chainObjects_ref.current = {};
        console.log('Is chain master: ', isChainMaster.current);
        console.log('Reset chain data: ', chainObjects_ref.current);

        //Add any quiz data to the activation so the backedn can get the commands used in the quizzes
        let quizData = [];
        for(let i=0; i< campaignContext.campaignData.features.length; i++)
        {
            let feature = campaignContext.campaignData.features[i];
            if(feature.varKey == 'quizPoll')
            {
                console.log('CONTAINS QUIZ')
                for(const customisation of campaignContext.campaignData.customisations)
                {
                    if(customisation.var == feature._id+'.quizdata.quizdata.quizzes')
                    {
                        for(const rawQuizData of customisation.value)
                        {
                            if (rawQuizData.quizID && rawQuizData.quizID.quiz) {
                                quizData.push({featureID:feature._id, quizID:rawQuizData.quizID.quiz._id})
                            }
                        }
                    }
                }
            }
        }
        console.log(channelList)
        console.log('Sending activate payload, channelList:', JSON.stringify(streamData.channels, null, 2));
        axios.post(activateStreamRoute, {
          streamID: streamId,
          campaignID: campaignId,
          channel: streamData.twitchHandle,
          channelList: streamData.channels,
          bots: campaignContext.campaignData.chatbots,
          quizData:quizData,
          hashtagCommands:campaignContext.campaignData.hashtagCommands,
          isBotAuthorised:true,
          withCredentials:true
        })
        .then(function (response) {
            console.log(response.data)
            setBotAuthorised(response.data.botAuthorised);
            //toast.success(response.data.message);
            setChatConnected(true);
            setConnecting(false);
            // See if the sever has some chain data (ie. we are not the first dashboard to conenct!)
            chainUpdateReceived_ref.current = false;
            setChainUpdateReceived(false);
            requestChainDataFromServer();
            setTimeout(() => {
                pollForChains(true);
            }, 3000);
            requestLiveStreamStateFromServer();
        })
        .catch(function (error) {
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
            setConnecting(false);
        });

    }

    const checkConnectionStatus = (streamID) => {
        console.log('Checking connection status...', streamID);
        axios
        .get(streamConnectionStatusRoute, {
            params: {  streamID:streamID },
            withCredentials:true
        })
        .then(function (response) {
            setChatConnected(response.data.active);
            if (response.data.active) {
                // See if the sever has some chain data (ie. we are not the first dashboard to conenct!)
                requestChainDataFromServer();
                requestLiveStreamStateFromServer();
            } else {
                // Only show the wizard if the stream has never been activated (DB status is 'scheduled').
                // If status is 'live' or 'ended', the stream was previously connected — don't interrupt
                // with the wizard just because the backend's in-memory connection state was lost (e.g. restart).
                if (response.data.streamStatus === 'scheduled') {
                    setShowWizard(true);
                }
            }
        })
        .catch(function (error) {
            setChatConnected(false);
        });
    }
    
    const checkBotStatus = (channel) => {
        console.log('Checking bot status...', channel);
        axios
        .get(checkBotStatusRoute, {
            params: { channel:channel },
            withCredentials:true
        })
        .then(function (response) {
            console.log('BOTY AUTH:', response.data.botAuthorised)
            setBotAuthorised(response.data.botAuthorised);
        })
        .catch(function (error) {
            setBotAuthorised(false);
        });
    }

    const checkStreamerStatus = (channel) => {
        axios
        .get(twitchStreamerExistsRoute, {
            params: { channel:channel },
            withCredentials:true
        })
        .then(function (response) {
            console.log('STREAMER EXISTS', response.data.exists)
            setStreamerExists(response.data.exists);
        })
        .catch(function (error) {
            setStreamerExists(false);
        });
    }

    const sendChatMsg = (e,name, copy, id) => {
        if (e) {
            e.preventDefault();
        }
        axios
        .post(sendBotChatMessageRoute, {
            botDetails:{
                name:name,
                copy:copy,
                id:id,
            },
            streamID:streamId,
            channel:streamData.twitchHandle,
            isBotAuthorised:false,
            withCredentials:true
        })
        .then(function (response) {
            toast.success(response.data.message);
        })
        .catch(function (error) {
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
        });

    }

    const endStream = (e) => {
        e.preventDefault();
        console.log('End Stream!');

        // Stop analytics collection on the server
        axios
            .post(stopStreamAnalyticsRoute, {
                streamID: streamId,
                withCredentials: true
            })
            .catch((error) => {
                console.log('stopStreamAnalytics error', error);
            });

        // Stop chat/stream state and timers
        deactivateChat(e);
        setStreamStarted(false);
        setStreamLiveTime(null);
        setChatConnected(false);

        // Stop features; heartbeat ignores updates when streamStartedRef is false
        if (socket.current) {
            try {
                isEndingStream.current = true;
                socket.current.emit('forceFeatureStop', { streamID: streamId });
            } catch (err) {
                isEndingStream.current = false;
                console.log('forceFeatureStop emit error', err);
            }
        }

        // Show review popup
        setShowRatingPopup(true);
    }


    const pullInCampaignData = () => {
        if (campaignId) {
            axios
                .get(getCampaignOverviewRoute, { params: { campaignID: campaignId }, withCredentials: true })
                .then(async (response) => {
                    campaignData_ref.current = response.data.campaignData;
                    setCampaignContext((oldValues) => {
                        return { ...oldValues, initialising: false, campaignData: response.data.campaignData }
                    })
                    findStream(response.data.campaignData);

                    console.log('Check for active expedition...');
                    const expoData = await EXPEDITION_LIVE_STATE.getActiveExpedition();
                    setExpeditionDataFetched(true);
                    console.log('Active expedition data: ', expoData);
                })
                .catch((error) => {
                    toast.error("Error fetching campaign data");
                    navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
                });
        } else {
            navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
        }
    }

    useEffect(() => {
        // Commented out the bit where we skip pulling in campaignData as it causes a bug when adding new disruptors.
        // *** This IS NOT the fix! This is a TEMPORARY measure! ***

        /* if (campaignContext.campaignData && campaignContext.campaignData._id === campaignId) {
            // we already have our campaign data available!
            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: false }
            });

            findStream();
        } else {
            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: true }
            });
            // setTimeout(pullInCampaignData, 2000);
            pullInCampaignData();
        } */
        pullInCampaignData();

        // Return a cleanup function to close the socket when we leave the page, otherwise we get sockets hanging around!
        return () => {
            if (socket.current) {
                socket.current.close();
            }
            socket.current = null;
        }
    }, [campaignId, streamId]); // eslint-disable-line react-hooks/exhaustive-deps


    /* ---- Bot stuff ---- */
    const triggerBotPost = (e, bot, messageIndex = null) => {
        console.log('Trigger Bot Post: ', bot, messageIndex);
        if(messageIndex == null)   messageIndex = Math.floor(Math.random() * bot.botCopy.length)
        // Send the message
        sendChatMsg(e, bot.name, bot.botCopy[messageIndex], bot.id);
    }

    const pauseBot = (e, bot) => {
        console.log('Pause Bot: ', bot);
        axios
        .post(pauseBotRoute, {
            campaignID: campaignId, 
            streamID: streamId, 
            botID:bot.id,
            withCredentials:true
        })
        .then(function (response) {
            console.log(response.data);
            setTimedBots(response.data.timedBots);
            response.data.pauseStatus ? toast.success('Bot successfully paused') :  toast.success('Bot successfully started')
            // featureVars.current = response.data.streamVars;
            // setInitialised(true);
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
            // console.log(error.response)
        });
    }

    const unpauseBot = (e, bot) => {
        console.log('Unpause Bot: ', bot);
    }
    /* ---- End of Bot suff ---- */

    const startCountdown = (e) => {
        e.preventDefault();
        if (chatConnected) {
            console.log('Start Countdown!');
        } else {
            console.log('Need to Go Live first');
        }
    }

    const startStream = (e) => {
        e.preventDefault();
        // Ensure socket exists
        if (!socket.current) {
            createNewSocketConnection();
        }
        if (chatConnected || socket.current) {
            console.log('Start Stream!');
            axios
            .post(startLiveStreamRoute, {
                campaignID:campaignId,
                streamID:streamId,
                withCredentials:true
            })
            .then(function (response) {
                toast.success(response.data.message);
                // See if the sever has some chain data (ie. we are not the first dashboard to conenct!)
                /* requestChainDataFromServer(); */
            })
            .catch(function (error) {
                toast.error('Error - ' + error/*.response.data.message*/);
                // console.log(error.response)
            });
            setStreamStarted(true);
            analyticsAvailable.current = true;
            streamStartedRef.current = true;
        } else {
            console.log('Need to Go Live first');
        }
    }

    const changeStreamStatus = (newStatus) => {
        axios
        .post(changeStreamStatusRoute, {
            campaignID: campaignId, _id:streamId, status: newStatus,
            withCredentials:true
        })
        .then(function (response) {
            streamData.status = newStatus;
            setStreamData({...streamData});
            toast.success('Stream status updated')
        })
        .catch(function (error) {
            console.log(error)
            toast.error('There was a problem updating the stream status')
        });
    }

    // CHAINS - used for intros / outros / feature countdowns!
    //
    // So here's the flow for this:
    //
    // Feature chains can be created locally at any time, but are only emitted to the server if the campaign has started
    //      (similarly, we should only be able to activate a chain if the campaign has started)
    // When we start a campaign, we emit a chainUpdateUp socket message with an empty object,
    //      this acts as a request for the server's (source of truth) chain states.
    // The server then emits a chainUpdateDown socket message, we can test if this is empty and if so, build all our feature chains
    //      and emit them to the server.
    // The server sends a chainUpdateDown socket message whenever it receives a chainUpdateUp (after updating it's chains), which
    //      keeps all dashboard instances in sync.
    // The server also sends a chainUpdateDown socket message when the feature page progresses through an active chain, so we can keep track
    //      on each dashboard instance.
    // Note the isChainMaster ref: this is set on the client where the user clicked the connect button, meaning only one dashboard instance
    //      will build and emit the chain data.

    const isChainMaster = useRef(false);
    const chainObjects_ref = useRef({});
    const [chainObjects, setChainObjects] = useState(null);
    const chainUpdateReceived_ref = useRef(false);
    const [chainUpdateReceived, setChainUpdateReceived] = useState(false);
    const getStepPrimaryChainItemIndex = (chainItems, itemIndex) => {
        const chainItem = chainItems?.[itemIndex];
        if (!chainItem) {
            return itemIndex;
        }

        const stepIndex = chainItem.stepIndex ?? 0;
        for (let i = itemIndex; i >= 0; i--) {
            if ((chainItems[i]?.stepIndex ?? 0) !== stepIndex) {
                return i + 1;
            }
        }

        return 0;
    }
    const setChainStepEnabledState = (chainData, itemIndex, enabled) => {
        const chainItems = chainData?.chainItems;
        const chainItem = chainItems?.[itemIndex];
        if (!chainItem) {
            return;
        }

        const stepIndex = chainItem.stepIndex ?? 0;
        const primaryItemIndex = getStepPrimaryChainItemIndex(chainItems, itemIndex);
        if (itemIndex !== primaryItemIndex) {
            chainItems[itemIndex].enabled = enabled;
            return;
        }

        for (let i = 0; i < chainItems.length; i++) {
            if ((chainItems[i]?.stepIndex ?? 0) === stepIndex) {
                chainItems[i].enabled = enabled;
            }
        }
    }
    const setChainItemVal = (chainId, itemIndex, key, val) => {
        if (key === 'enabled') {
            setChainStepEnabledState(chainObjects_ref.current[chainId], itemIndex, val);
        } else {
            chainObjects_ref.current[chainId].chainItems[itemIndex][key] = val;
        }
        setChainObjects({...chainObjects_ref.current});
        if (chatConnected) {
            console.log('Emitting chain update!');
            socket.current.emit('chainUpdateUp', {streamID:streamId, chains:chainObjects_ref.current});
        }
    }
    const startChain = (chainId) => {
        if (chatConnected && !chainObjects_ref.current[chainId].active) {
            socket.current.emit('chainStart', {streamID:streamId, chainId:chainId});
        }
    }
    const getActiveChainFeatureIds = (chainId) => {
        const chainData = chainObjects_ref.current[chainId];
        if (!chainData?.chainItems) {
            return [];
        }

        const featureIds = new Set();
        if (Array.isArray(chainData.activeItemIndexes)) {
            chainData.activeItemIndexes.forEach((activeIndex) => {
                const activeItem = chainData.chainItems[activeIndex];
                if (activeItem?.featureId) {
                    featureIds.add(activeItem.featureId);
                }
            });
        }

        const currentItem = chainData.chainItems[chainData.index];
        if (currentItem?.featureId) {
            featureIds.add(currentItem.featureId);
        }

        return Array.from(featureIds);
    }
    const stopChain = (chainId) => {
        if (chatConnected && chainObjects_ref.current[chainId].active) {
            socket.current.emit('chainStop', {streamID:streamId, chainId:chainId});
            getActiveChainFeatureIds(chainId).forEach((featureId) => {
                socket.current.emit('refreshFeature', {streamID: streamId, featureID: featureId});
            });
        }
    }

    const [chainSkipAllowed, setChainSkipAllowed] = useState(true);
    const [forceSkipAllowed, setForceSkipAllowed] = useState(false);
    const skipChainItem = (chainId, chainItemIndex, featureId) => {
        endFeature(featureId);
        // Fail-safe in case features have a bug where they don't send the feature ended message
        // Give it a second then first a socket message to advance the chain.
        // The server will respoond to this message, advancing the chain but only if the itemIndex we send is the current index.
        setChainSkipAllowed(false);
        setForceSkipAllowed(false);
        setTimeout(() => {
            setForceSkipAllowed(true);
        }, 1000);
        /* setTimeout(() => {
            socket.current.emit('chainSkipItem', {streamID:streamId, chainId:chainId, chainItemIndex:chainItemIndex});
            setChainSkipAllowed(true);
        }, 5000); */
    }

    const forceChainSkip = (chainId, chainItemIndex, featureId) => {
        endFeature(featureId);
        socket.current.emit('chainSkipItem', {streamID:streamId, chainId:chainId, chainItemIndex:chainItemIndex});
    }

    const endFeature = (triggerEndFeatureId) => {
        // Find the correct command
        const campaignData = campaignData_ref.current || campaignContext.campaignData;
        let featureData_end = null;
        if (campaignData && campaignData.features) {
            for (let i = 0; i < campaignData.features.length; i++) {
                if (campaignData.features[i]._id === triggerEndFeatureId) {
                    featureData_end = campaignData.features[i];
                }
            }
            if (featureData_end) {
                console.log('Find end command: ', featureData_end);
                let commandString_end = '';
                for (let i = 0; i < featureData_end.feature.commands.length; i++) {
                    if (featureData_end.feature.commands[i].isEndTrigger) {
                        commandString_end = featureData_end.feature.commands[i].command;
                    }
                }
                if (commandString_end) {
                    console.log('Emitting end feature command: ', commandString_end, triggerEndFeatureId);
                    if (socket.current) {
                        const timestamp = Date.now();
                        // We are connected - emit a socket message so our triggered feature gets logged and all that (just like clicking the control button)
                        socket.current.emit('triggerFeatureEnd', {streamID: streamId, timestamp: timestamp, featureID: triggerEndFeatureId, triggerFeatureID: triggerEndFeatureId, command: commandString_end});
                    }
                }
            }
        }
    }

    const chainPollCount_ref = useRef(0);
    const pollForChains = (initialCall = false) => {
        if (initialCall) {
            chainPollCount_ref.current = 0;
        } else {
            chainPollCount_ref.current++;
        }
        if (!chainUpdateReceived_ref.current && chatConnected && chainPollCount_ref.current < 10) {
            requestChainDataFromServer();
            setTimeout(() => pollForChains(), 3000);
        }
    }

    const requestChainDataFromServer = () => {
        console.log('Request chain data from server!');
        // We send up an empty object, which is a request for the server's (source of truth) chain states.
        if (socket.current) {
            socket.current.emit('chainUpdateUp', {streamID:streamId, chains:{}});
        }
    }

    const requestLiveStreamStateFromServer = () => {
        if (socket.current) {
            socket.current.emit('requestLiveStreamState', {streamID:streamId});
        }
    }

    const serverChainsNeedRefresh = (serverChains, campaignData) => {
        if (!campaignData || !Array.isArray(campaignData.chains) || campaignData.chains.length === 0) {
            return false;
        }

        for (let i = 0; i < campaignData.chains.length; i++) {
            const chainId = deriveChainId(i, campaignData);
            const rawChainData = campaignData.chains[i];

            if (!chainId || !Array.isArray(rawChainData) || rawChainData.length === 0) {
                continue;
            }

            const expectedSignature = JSON.stringify(rawChainData);
            const expectedItemCount = rawChainData.reduce((count, chainItem) => {
                const parsedChainItem = CHAINS_HELPER.parseChainItem(chainItem);
                return parsedChainItem?.featureId ? count + 1 : count;
            }, 0);
            const serverChain = serverChains?.[chainId];

            if (!serverChain) {
                return true;
            }

            if (serverChain.rawChainSignature !== expectedSignature) {
                return true;
            }

            if (!Array.isArray(serverChain.chainItems) || serverChain.chainItems.length !== expectedItemCount) {
                return true;
            }
        }

        return false;
    }

    const buildAllFeatureChainsAndSendToServer = (receivedCampaignChainData = null) => {
        // Weirdly can't seem to access campaignContext from this function after a refresh,
        // even though it works fine elsewhere...
        console.log('Build all feature chains and send to server: ', receivedCampaignChainData, campaignContext.campaignData);

        // isChainMaster is set on the client where the user clicked the connect button,
        // meaning only one dashboard instance will build and emit the chains.
        if (!isChainMaster.current) {
            return;
        }
        
        const campaignData = campaignData_ref.current || campaignContext.campaignData;

        // First things first - if we have some received campaign chain data, use that!
        // The server is our ultimate source of truth, but only needs to provide the basic chain data, we can build the chain objects here.
        if (receivedCampaignChainData) {
            console.log('Updating campaign chain data: ', receivedCampaignChainData);
            campaignData.chains = receivedCampaignChainData;
            if (isChainMaster.current) {
                chainObjects_ref.current = {};
            }
        }

        console.log('CAMPAIGN DATA ===============', campaignData)
        let gotChains = false;
        if (campaignData && campaignData.features && campaignData.features.length > 0 && campaignData.chains && campaignData.chains.length > 0) {
            for (let i = 0; i < campaignData.chains.length; i++) {
                const chainId = deriveChainId(i, campaignData);
                console.log('Derived chainId: ', chainId, campaignData.chains[i]);
                if (chainId) {
                    const builtChain = buildFeatureChainStateObject(chainId, campaignData, receivedCampaignChainData);
                    if (builtChain.chainItems && builtChain.chainItems.length > 0) {
                        gotChains = true;
                        builtChain.chainItems[builtChain.chainItems.length - 1].loop = false;
                        builtChain.chainItems[builtChain.chainItems.length - 1].loopDelay = 0;
                        builtChain.looping = false;
                    }
                }
            }
            /* for (let i = 0; i < campaignData.features.length; i++) {
                if (campaignData.features[i].feature.featureType === 'feature') {
                    const featureChain = buildFeatureChainStateObject(campaignData.features[i]._id, campaignData, receivedCampaignChainData);
                    if (featureChain.chainItems && featureChain.chainItems.length > 0) {
                        gotChains = true;
                    }
                }
            } */
        } // else {
            // Campaign data not avilable...
            // Try again in a moment...
            // setTimeout(buildAllFeatureChainsAndSendToServer, 1000);
        // }

        if (gotChains) {
            console.log('UP DATA', streamId, chainObjects_ref.current)
            socket.current.emit('chainUpdateUp', {streamID:streamId, chains:chainObjects_ref.current});
        }

        isChainMaster.current = false;
    }

    const buildFeatureChainStateObject = (chainId, _campaignData = null, receivedCampaignChainData = null) => {
        const campaignData = _campaignData || campaignContext.campaignData;
        /* // First things first - if we have some received campaign chain data, use that!
        // The server is our ultimate source of truth, but only needs to provide the basic chain data, we can build the chain objects here.
        if (receivedCampaignChainData) {
            console.log('Updating campaign chain data: ', receivedCampaignChainData);
            campaignData.chains = receivedCampaignChainData;
            if (isChainMaster.current) {
                chainObjects_ref.current = {};
            }
        } */
        // console.log('Build chain obj: ', featureId, campaignData);
        let featureData = null;
        let rawChainData = null;
        /* for (let i = 0; i < campaignData.features.length; i++) {
            if (campaignData.features[i]._id === featureId) {
                // our feature!
                featureData = campaignData.features[i];
                break;
            }
        }
        for (let i = 0; i < campaignData.chains.length; i++) {
            if (chainContainsFeature(campaignData.chains[i], featureId)) {
                // our chain!
                rawChainData = campaignData.chains[i];
                break;
            }
        } */

        // Look for out raw chain data. To do this we need to generate the chainId, we do this as follows:
        // campaignData.chains is a basic array of arrays container feature IDs.
        // We step through the feature IDs in the chain and if one is a feature type then that is the Id we derive our chainId from,
        // otherwise we use the first feature ID in the chain.
        // Then we add and _ and thhe index of the chain in the campaignData.chains array.
        let derivedChainId = null;
        for (let i = 0; i < campaignData.chains.length; i++) {
            derivedChainId = deriveChainId(i, campaignData);
            if (chainId === derivedChainId) {
                // found our chainId
                rawChainData = campaignData.chains[i];
                break;
            }
            /* if (campaignData.chains[i].indexOf(featureId) >= 0) {
                // our chain!
                rawChainData = campaignData.chains[i];
                break;
            } */
        }

        if (!rawChainData) {
            // No chain data found return an empty object
            console.log('No chain data found for chainId: ', chainId);
            return {};
        }

        const rawChainSignature = JSON.stringify(rawChainData);

        // console.log('Chain data (raw): ', rawChainData, featureData);
        let builtChainData = null;
        const existingChainState = chainObjects_ref.current[chainId];
        if (existingChainState && existingChainState.rawChainSignature === rawChainSignature) {
            // fetch it (this stuff is persistent)!
            console.log('Using persitent chain data: ', existingChainState);
            builtChainData = existingChainState.chainItems;
        } else {
            // build it
            builtChainData = [];
            let currentStepIndex = 0;

            // now go through our feature chain, intro, feature, outro...
            for (let i = 0; i < rawChainData.length; i++) {
                const parsedChainItem = CHAINS_HELPER.parseChainItem(rawChainData[i]);
                if (!parsedChainItem || !parsedChainItem.featureId) {
                    continue;
                }

                const chainStepData = {};
                chainStepData.enabled = true;
                chainStepData.featureId = parsedChainItem.featureId;
                chainStepData.startType = parsedChainItem.startType;
                chainStepData.startDelay = parsedChainItem.startDelay;
                chainStepData.endType = parsedChainItem.endType;
                chainStepData.stepLength = parsedChainItem.stepLength || 1;
                chainStepData.componentName = parsedChainItem.componentName || null;
                chainStepData.commandParam = parsedChainItem.commandParam;
                chainStepData.stepIndex = currentStepIndex;
                chainStepData.endStepIndex = currentStepIndex + chainStepData.stepLength - 1;
                // Find the command!
                for (let j = 0; j < campaignData.features.length; j++) {
                    if (campaignData.features[j]._id === parsedChainItem.featureId) {
                        // found the feature...
                        for (let k = 0; k < campaignData.features[j].feature.commands.length; k++) {
                            if (campaignData.features[j].feature.commands[k].isPrimaryTrigger) {
                                // Found our trigger command
                                chainStepData.command = campaignData.features[j].feature.commands[k].command;
                                break;
                            }
                        }
                        if (chainStepData.command === undefined) {
                            // We didn't find a trigger command...
                            chainStepData.command = campaignData.features[j].feature.commands[0].command;
                            break;
                        }
                    }
                }
                
                builtChainData.push(chainStepData);
                                if (chainStepData.endType === CHAINS_HELPER.END_TYPE_FEATURE_END) {
                                    currentStepIndex++;
                                }
            }
            if (builtChainData.length > 0) {
                // Ensure the last item is always set to end when the feature ends
                builtChainData[builtChainData.length - 1].endType = CHAINS_HELPER.END_TYPE_FEATURE_END;
            }

                            chainObjects_ref.current[chainId] = {
                                active: existingChainState?.active || false,
                                index: existingChainState?.index || 0,
                                activeItemIndexes: existingChainState?.activeItemIndexes || [],
                                looping: existingChainState?.looping || false,
                                rawChainSignature,
                                chainItems: builtChainData
                            };
            setChainObjects({...chainObjects_ref.current});
        }
        console.log('Built chains: ', chainObjects_ref.current, builtChainData);
        return chainObjects_ref.current && chainObjects_ref.current[chainId] ? chainObjects_ref.current[chainId] : {};
    }

    const getChainIndexFromId = (chainId, campaignData) => {
        if (!campaignData?.chains) {
            return -1;
        }

        for (let i = 0; i < campaignData.chains.length; i++) {
            if (deriveChainId(i, campaignData) === chainId) {
                return i;
            }
        }

        return -1;
    }

    const getChainStepNames = (chainId) => {
        const campaignData = campaignContext.campaignData;
        const chainIndex = getChainIndexFromId(chainId, campaignData);
        if (chainIndex < 0) {
            return [];
        }

        return campaignData.chainMetadata?.[chainIndex]?.stepNames || [];
    }

    const getChainStepGroups = (chainId, chainItems = []) => {
        const stepNames = getChainStepNames(chainId);
        const groupedStepsMap = new Map();

        chainItems.forEach((item, index) => {
            const startStepIndex = item.stepIndex ?? 0;
            const endStepIndex = item.endStepIndex ?? startStepIndex;

            for (let stepIndex = startStepIndex; stepIndex <= endStepIndex; stepIndex++) {
                if (!groupedStepsMap.has(stepIndex)) {
                    groupedStepsMap.set(stepIndex, {
                        stepIndex,
                        title: stepNames[stepIndex] || `Step ${stepIndex + 1}`,
                        primaryItemIndex: null,
                        items: []
                    });
                }

                const stepGroup = groupedStepsMap.get(stepIndex);
                const isExpandedCopy = stepIndex !== startStepIndex;
                if (!isExpandedCopy && stepGroup.primaryItemIndex === null) {
                    stepGroup.primaryItemIndex = index;
                }

                stepGroup.items.push({ item, index, isExpandedCopy });
            }
        });

        return Array.from(groupedStepsMap.values())
            .sort((a, b) => a.stepIndex - b.stepIndex)
            .map((stepGroup) => ({
                ...stepGroup,
                items: [...stepGroup.items].sort((a, b) => {
                    if (a.isExpandedCopy !== b.isExpandedCopy) {
                        return a.isExpandedCopy ? 1 : -1;
                    }

                    return a.index - b.index;
                })
            }));
    }

    /* const buildFeatureChainStateObject = (featureId, _campaignData = null, receivedCampaignChainData = null) => {
        const campaignData = _campaignData || campaignContext.campaignData;
        // First things first - if we have some received campaign chain data, use that!
        // The server is our ultimate source of truth, but only needs to provide the basic chain data, we can build the chain objects here.
        if (receivedCampaignChainData) {
            console.log('Updating campaign chain data: ', receivedCampaignChainData);
            campaignData.chains = receivedCampaignChainData;
            if (isChainMaster.current) {
                chainObjects_ref.current = {};
            }
        }
        // console.log('Build chain obj: ', featureId, campaignData);
        let featureData = null;
        let rawChainData = null;
        for (let i = 0; i < campaignData.features.length; i++) {
            if (campaignData.features[i]._id === featureId) {
                // our feature!
                featureData = campaignData.features[i];
                break;
            }
        }
        for (let i = 0; i < campaignData.chains.length; i++) {
            if (chainContainsFeature(campaignData.chains[i], featureId)) {
                // our chain!
                rawChainData = campaignData.chains[i];
                break;
            }
        }
        // console.log('Chain data (raw): ', rawChainData, featureData);
        let builtChainData = null;
        if (chainObjects_ref.current[featureId]) {
            // fetch it (this stuff is persistent)!
            console.log('Using persitent chain data: ', chainObjects_ref.current[featureId]);
            builtChainData = chainObjects_ref.current[featureId].chainItems;
        } else {
            // build it
            builtChainData = [];

            // now go through our feature chain, intro, feature, outro...
            for (let i = 0; i < rawChainData.length; i++) {
                const chainStepData = {};
                chainStepData.enabled = true;
                chainStepData.featureId = rawChainData[i];
                // Find the command!
                for (let j = 0; j < campaignData.features.length; j++) {
                    if (campaignData.features[j]._id === rawChainData[i]) {
                        // found the feature...
                        for (let k = 0; k < campaignData.features[j].feature.commands.length; k++) {
                            if (campaignData.features[j].feature.commands[k].isPrimaryTrigger) {
                                // Found our trigger command
                                chainStepData.command = campaignData.features[j].feature.commands[k].command;
                                break;
                            }
                        }
                        if (chainStepData.command === undefined) {
                            // We didn't find a trigger command...
                            chainStepData.command = campaignData.features[j].feature.commands[0].command;
                            break;
                        }
                    }
                }
                
                builtChainData.push(chainStepData);
            }

            chainObjects_ref.current[featureId] = {active: false, index: 0, chainItems: builtChainData};
            setChainObjects({...chainObjects_ref.current});
        }
        console.log('Built chains: ', chainObjects_ref.current, builtChainData);
        return chainObjects_ref.current && chainObjects_ref.current[featureId] ? chainObjects_ref.current[featureId] : {};
    } */

    const countChainItems = () => {
        const returnData = {items: 0, lastFeatureId: null};
        const campaignData = campaignContext.campaignData;
        if (campaignData && campaignData.chains) {
            for (let i = 0; i < campaignData.chains.length; i++) {
                for (let j = 0; j < campaignData.chains[i].length; j++) {
                    returnData.items++;
                    returnData.lastFeatureId = campaignData.chains[i][j];
                }
            }
        }
        return returnData;
    }

    // Force Stop stuff
    const [showForceStopPopup, setShowForceStopPopup] = useState(false);
    const forceStopHandler = () => setShowForceStopPopup(true);
    const closeForceStopPopup = () => setShowForceStopPopup(false);
    const forceStopNow = () => {
        axios
        .post(stopStreamAnalyticsRoute, {
            streamID: streamId, 
            withCredentials:true
        })
        .then(function (response) {
            toast.success('Analytics ended, extension refreshing!');
            setStreamStarted(false);
            socket.current.emit('forceFeatureStop', {streamID: streamId});
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
        });
    }

    const getTabData = () => {
        return [
            { label: 'Stream Manager' },
            { label: 'Campaign Flows' },
            { label: 'All Features/ Components' },
            { label: 'Bots' },
            { label: 'Analytics', disabled: !analyticsAvailable.current },
        ];
    }

    const findFeatureData = (featureId) => {
        for (let i = 0; i < campaignData_ref.current.features.length; i++) {
            if (campaignData_ref.current.features[i]._id === featureId) {
                return campaignData_ref.current.features[i];
            }
        }
        return null;
    }

    const gotFeature = () => {
        if (campaignData_ref.current && campaignData_ref.current.features) {
            for (let i = 0; i < campaignData_ref.current.features.length; i++) {
                if (campaignData_ref.current.features[i].feature.featureType === 'feature') {
                    return true;
                }
            }
        }
        return false;
    }

    const selectDisruptor = (d) => {
        console.log('Select distruptor: ', d);
        setPreviewMode(false);
        changeFeature(d);
    }

    const getChainedDisruptorPanel = (item, featureData, i, chainId = null, isExpandedCopy = false, showInlineExpandedMarker = false) => {
        console.log('Get disruptor panel for: ', item, featureData);

        let boxStyle = featureData.feature.featureType;
        if (LEFT_COLOR_BLOCK_STYLES[featureData.feature.featureType + '_' + featureData.feature.varKey]) {
            boxStyle = featureData.feature.featureType + '_' + featureData.feature.varKey;
        }
        if (LEFT_COLOR_BLOCK_STYLES['disruptor_' + featureData.feature.colourCategory]) {
            boxStyle = 'disruptor_' + featureData.feature.colourCategory;
        }
        if (LEFT_COLOR_BLOCK_STYLES['category_' + featureData.feature.colourCategory]) {
            boxStyle = 'category_' + featureData.feature.colourCategory;
        }
        const componentCategory = featureData.feature.iconCategory || featureData.feature.featureCategory;
        const componentColor = componentCategory ? getIconCategoryColor(componentCategory) : null;
        
        return (
            <div className="fl-column compact" key={'disruptor_' + i}>
                <div className="fl-row grow">
                    <LeftColorBlockBox
                        style={boxStyle}
                        overrideBgColor={currentFeature === featureData ? '#DDDDEE' : ''}
                        customColor={componentColor}
                        customIcon={featureData.feature.icon}
                        customIconVarKey={featureData.feature.varKey}
                        whiteIcon={Boolean(componentColor)}
                        neutralBorder={true}
                        iconBoxOnly={true}
                        compact={true}
                        className={`feature-chain-card${currentFeature === featureData ? ' is-selected' : ''}${item.enabled ? '' : ' is-disabled'}${isExpandedCopy ? ' is-expanded-copy' : ''}`}
                        onClickHandler={() => selectDisruptor(featureData)}
                    >
                        <div className="fl-row list-view-content">

                            <div className="grow feature-chain-text">
                                <div className="feature-chain-title">{featureData.contentLabel || `Disruptor Name #${i + 1}`}</div>
                                <div className="feature-chain-subtitle">({featureData.feature.featureName})</div>
                                {isExpandedCopy &&
                                    <div className="feature-chain-subtitle">Expanded from Step {(item.stepIndex ?? 0) + 1}</div>
                                }
                                {item.startType === CHAINS_HELPER.START_TYPE_MANUAL &&
                                    <>
                                        <span className={`small-text warning-text`}>
                                            REQUIRES MANUAL START
                                        </span>
                                    </>
                                }
                                {item.startType === CHAINS_HELPER.START_TYPE_AUTO && item.startDelay > 0 &&
                                    <>
                                        <span className={`small-text warning-text`}>
                                            +{item.startDelay} SECOND DELAY
                                        </span>
                                    </>
                                }
                            </div>

                            <div className="fl-row shrink chain-selector-actions">
                                {showInlineExpandedMarker &&
                                    <div className="feature-chain-expanded-linkage feature-chain-expanded-linkage-inline" aria-hidden="true">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.share, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                    </div>
                                }
                                {chatConnected &&
                                    <button
                                        type="button"
                                        className={`chain-selector-toggle${item.enabled ? ' is-enabled' : ''}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setChainItemVal(chainId, i, 'enabled', !item.enabled);
                                        }}
                                        aria-label={item.enabled ? 'Disable chain component' : 'Enable chain component'}
                                        title={item.enabled ? 'Disable component' : 'Enable component'}
                                    >
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.powerOff, IconJsxer.ICON_STYLES.chainComponentToggle)}
                                    </button>
                                }

                                <div className="edit-icon feature-chain-settings-icon" onClick={(e) => { e.stopPropagation(); selectDisruptor(featureData); }}>
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.controls, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                </div>
                            </div>

                        </div>
                    </LeftColorBlockBox>
                </div>
            </div>
        )
    }

    const [showRatingPopup, setShowRatingPopup] = useState(false);
    const closeRatingPopup = () => setShowRatingPopup(false);
    const getCurrentRating = () => {
        let  currentRating = 0;

        if (campaignData_ref.current) {
            let streamData = null;
            for (let i = 0; i < campaignData_ref.current.streams.length; i++) {
                if (campaignData_ref.current.streams[i]._id === streamId) {
                    streamData = campaignData_ref.current.streams[i];
                    break;
                }
            }

            if (streamData && streamData.ratings) {
                let totalRating = 0;
                for (let i = 0; i < streamData.ratings.length; i++) {
                    totalRating += streamData.ratings[i].rating;
                }
                currentRating = Math.round(totalRating / streamData.ratings.length);
            }
        }

        return currentRating;
    }

    const [showingRestrictedCustomisationPopup, setShowingRestrictedCustomisationPopup] = useState(false);
    const closeRestrictedCustomisationPopup = () => setShowingRestrictedCustomisationPopup(false);
    const restrictedCustomisationTitle = useRef(null);
    const restrictedCustomisationFeatureId= useRef(null);
    const restrictedCustomisationTab = useRef(null);
    const restrictedCustomisationGroup = useRef(null);
    const restrictedCustomisationFamily = useRef(null);
    const openRestrictedCustomisationPopup = (featureId, title, tab, group, family) => {
        restrictedCustomisationTitle.current = title;
        restrictedCustomisationFeatureId.current = featureId;
        restrictedCustomisationTab.current = tab;
        restrictedCustomisationGroup.current = group;
        restrictedCustomisationFamily.current = family;
        setShowingRestrictedCustomisationPopup(true);
    }

    const [channelList, setChannelList] = useState([])
    const getChannels = () => {
   
        if(streamData)
        {
            return(
                <div className='connectedChannelList'>
                    {channelList.map((val, i) => {
                        return(
                        <div key={"chan_" + i} className={`connectedChannel ${chatConnected ? 'connected' : 'disconnected'}`} style={{color: getChannelColour(getStreamChannelId(val)), border:"2px solid "+getChannelColour(getStreamChannelId(val))}}>
                             <img className='user-profile-pic-small' src={getStreamChannelProfilePic(val)}></img>
                            {getStreamChannelLabel(val)}
                        </div>
                        )

                    })
                    }
                </div>
          )
        }
        else
        {
            return(<></>)
        }
       

    }
    const getChannelColour = (channel) => {

        for(let i=0; i<channelList.length; i++)
        {
            if(channelList[i].twitchHandle.toLowerCase() == channel.toLowerCase() ) return CHANNEL_COLOURS[i%8];
        }
    }

    const getIsFeatureThemable = (featureData) => {
        let themeable = false;
        for (let i = 0; i < featureData.feature.customisation.length; i++) {
            if (featureData.feature.customisation[i].themeable) {
                themeable = true;
                break;
            }
        }
        return themeable;
    }

    const hasStreamChannels = Boolean(streamData?.channels?.length);
    const connectButtonDisabled = !hasStreamChannels || streamData?.status === 'ended';
    const connectButtonLabel = hasStreamChannels ? 'Connect to Channels' : 'No Channels Added';
    const campaignTitle = campaignContext.campaignData?.name || campaignContext.campaignData?.title || 'Campaign';
    const streamTitle = streamData?.name || streamData?.twitchHandle || 'Unnamed Stream';

    return (
        <div className="content-page-container" onMouseMove={setTooltipPosToMouse}>
            <div className="sticky-header content-page-top">

                <div className="top-info">
                    <div className="top-info-primary-row">
                        <div className="stream-header-main">
                            <div className="back-button" 
                                onClick={
                                    (e) => {
                                        navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW_TAB.replace(':id', campaignId).replace(':tab', 'streams'))
                                    }
                                }
                            >
                                {IconJsxer.GetIcon(IconJsxer.ICONS.chevronLeft, IconJsxer.ICON_STYLES.campaignPanelTop)}
                            </div>
                            <div className="fl-column no-gap grow stream-header-title-block">
                                <div className="stream-header-campaign-name">{campaignTitle}</div>
                                <h1><span className="stream-header-stream-name">{streamTitle}</span> <span className="stream-header-separator">|</span> <span className="stream-header-context-label">Stream Control</span></h1>
                            </div>
                        </div>
                        <div className="fl-column shrink right-status-block">
                            <div className="fl-row light-text stream-header-status-row">
                                <div className="grow"></div>
                                <div className="fl-row compact">
                                    <div className={`big-status-light ${featureReady ? '' : 'in'}active`}><img src={FeatureIcon} alt="" /></div>
                                    <div>
                                        Extensions Activated {'('+activatedFeatures+')'}
                                        {activatedFeatures > 1 &&
                                            <>
                                                <br/><span className="little-red-text-button small-text" onClick={() => setShowingKillOldFeaturesPopup(true)}>DEACTIVATE FEATURES</span>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="fl-row compact">
                                    <div className={`big-status-light ${audioEnabled ? '' : 'in'}active`}><img src={AudioIcon} alt="" /></div>
                                    <div>Audio/Video</div>
                                </div>
                                <div className="fl-row compact">
                                    <div className={`big-status-light ${chatConnected ? '' : 'in'}active`}><img src={ConnectIcon} alt="" /></div>
                                    <div>Connect</div>
                                </div>
                                <div className="fl-row compact">
                                    <div className={`big-status-light ${botAuthorised ? '' : 'in'}active`}><img src={BotIcon} alt="" /></div>
                                    <div>Bot</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="top-info-divider" />
                    <div className="top-info-secondary-row">
                        <div className="top-info-channels grow">
                            { getChannels()}
                        </div>
                        <div className="top-info-actions">
                            {!chatConnected && streamData &&
                                <>
                                    <button className={`standard-button${connectButtonDisabled ? ' button-inactive' : ''}`} onClick={connectButtonDisabled ? null : activateChat}>{connectButtonLabel}</button>
                                    {streamData && streamData.status !== 'ended' &&
                                        <button className="standard-button red-button" onClick={() => changeStreamStatus('ended')}>Set to Ended</button>
                                    }
                                    {streamData && streamData.status === 'ended' &&
                                        <button className="standard-button yellow-button" onClick={() => changeStreamStatus('scheduled')}>Set to Scheduled</button>
                                    }
                                </>
                            }
                            {chatConnected &&
                                <>
                                    {!streamStarted &&
                                        <>
                                            <div className="analytics-warning-callout">
                                                <div className="analytics-warning-callout-icon">
                                                    {IconJsxer.GetIcon(IconJsxer.ICONS.error, {height: '1.1rem'})}
                                                </div>
                                                <div className="analytics-warning-callout-copy">ANALYTICS & BOTS NOT ACTIVE!<br />Remember to enable analytics when running a live stream!</div>
                                            </div>
                                            <button className={`standard-button${connecting ? ' button-inactive' : ''}`} onClick={connecting ? null : startStream}>{connecting ? 'Finalising Connection...' : 'Start Analytics / Bots'}</button>
                                        </>
                                    }
                                    <button className="standard-button" onClick={endStream}>{streamStarted ? 'End Campaign' : 'Disconnect'}</button>
                                </>
                            }
                        </div>
                    </div>
                </div>

            </div>
            <div className="content-page-content-container">
                <div className="content-page-main-content">

                    <div className="stream-manager-tabs-shell">
                        <TabbedPanel
                            tabs={getTabData()}
                            switchTabCallback={(tabId, tabData) => {setCurrentTab(tabId); togglePreviewMode(false);}}
                            extraPanelClass="ms-tabbed-panel"
                        >
                            <div className="fl-column form-holder">
                            {currentTab === 0 &&
                                <>
                                    {/* The tab content component is completely reliant on props. 
                                        This way we can ensure all the settings remain in memory and
                                        we can have a single useEffect thatsends changes up to the server.
                                        Note the leading _ this is because we can't give the prop the same name...
                                    */}
                                    {streamData &&
                                        <TabStreamManager
                                            _streamLink={`${window.location.origin}/obs-feature/${campaignId}/${streamId}/321ABC`}
                                            _analyticsData={analyticsObj}
                                            _updateAnalyticsFunc={setAnalyticsObj}
                                            _streamID={streamId}
                                            _streamData={streamData}
                                            _streamStarted={streamStarted}
                                            _demoMode={demoMode}
                                            _draftMode={campaignContext.campaignData.draft}
                                            _streamLiveTime={streamLiveTime}
                                            _streamStartCountdown={streamStartCountdown}
                                            _setStreamStartCountdown={setStreamStartCountdown}
                                            _countdownTime={countdownTime}
                                            _setCountdownTime={setCountdownTime}
                                            _chatConnected={chatConnected}
                                            _connecting={connecting}
                                            _audioEnabled={audioEnabled}
                                            _hasChannels={hasStreamChannels}
                                            _canActivateChat={!connectButtonDisabled}
                                            _featureReady={featureReady}
                                            _startCountdown={startCountdown}
                                            _autoHideAfterCountdown={autoHideAfterCountdown}
                                            _setAutoHideAfterCountdown={setAutoHideAfterCountdown}
                                            _startStream={startStream}
                                            _overlayState={overlayState}
                                            _setOverlayState={setOverlayState}
                                            _adBug={adBug}
                                            _setAdBug={setAdBug}
                                            _adBugPosOptions={adBugPosOptions}
                                            _adBugPos={adBugPos}
                                            _setAdBugPos={setAdBugPos}
                                            _showTooltip={showTooltip}
                                            _hideTooltip={hideTooltip}
                                            _forceStop={forceStopHandler}
                                            _activateChat={activateChat}
                                        />
                                    }
                                </>

                                
                            }

                            {currentTab === 1 &&
                                <div className="fl-column no-panel-shadow tab1-wrapper">
                                    {(!chatConnected || !featureReady) &&
                                        <div className="tab1-overlay">
                                            {IconJsxer.GetIcon(IconJsxer.ICONS.error, {height: '3rem', opacity: 0.5})}
                                            <p>Campaign Flows will become active once an extension is activated and you have connected to the channels.</p>
                                        </div>
                                    }
                                    <div className={(!chatConnected || !featureReady) ? 'tab1-content tab1-content-hidden' : 'tab1-content'}>
                                    {campaignContext.campaignData.chains.length > 0 && chatConnected && featureReady &&
                                        <LeftColorBlockHeadedPanel
                                            style={previewMode ? 'preview_mode' : currentFeature ? 'campaign_live' : 'disabled_mode'}
                                            className="cf-status-panel"
                                            headingContent={
                                                <div className="cf-status-heading-text grow">
                                                    <div className="fl-row">
                                                        <h4>{previewMode ? 'Preview Mode' : 'Live Mode'}</h4>
                                                        <div className="grow"></div>
                                                        {currentFeature && chatConnected && featureReady &&
                                                            <button className="standard-button tight cf-dry-run-btn" onClick={() => togglePreviewMode(!previewMode, currentFeature, '')}>
                                                                {previewMode ? 'Exit Preview' : 'Test Preview'}
                                                            </button>
                                                        }
                                                    </div>
                                                    <div className="cf-status-body">
                                                        {!currentFeature && <>Please select a Feature or Disruptor to view its controls.</>}
                                                        {!previewMode && currentFeature && <>You are running in live mode. Commands will be sent to all active extension pages.</>}
                                                        {previewMode && <>Commands will be sent to the preview window. Note: settings changes will still be sent to active extension pages.</>}
                                                    </div>
                                                </div>
                                            }
                                        />
                                    }
                                    <div className="split-content">
                                        <div className="shrink-column">
                                            {campaignContext.campaignData.chains.length === 0 &&
                                                <h2>You have no feature chains set up.</h2>
                                            }
                                            {campaignContext.campaignData.chains.length > 0 &&
                                                <div className="chain-list-wrapper">
                                                    <div className="scroll-area _42">

                                                        {campaignContext.campaignData.chains.map(
                                                            (chainVal, chainIndex, arr) => {
                                                                const chainId = deriveChainId(chainIndex, campaignContext.campaignData);
                                                                if (chainId) {
                                                                    const featureChainStateObject = buildFeatureChainStateObject(chainId);
                                                                    /* if (val.feature.featureType === 'feature') {
                                                                        const featureChainStateObject = buildFeatureChainStateObject(val._id);
                                                                        console.log('Feature chain state: ', featureChainStateObject);

                                                                        // Check tabs in featureData for any themeable tabs
                                                                        const featureData = val;
                                                                        let themeable = false;
                                                                        for (let i = 0; i < featureData.feature.customisation.length; i++) {
                                                                            if (featureData.feature.customisation[i].themeable) {
                                                                                themeable = true;
                                                                                break;
                                                                            }
                                                                        } */
                                                                    
                                                                    // Find the feature data the chainId was drived from, so we can name ir properly.
                                                                    const chainIdFeatureData = findFeatureData(chainId.split('_')[0]);
                                                                    if (!chainIdFeatureData) {
                                                                        return null;
                                                                    }

                                                                    let chainItemNumber = 0;
                                                                    let showChainItemNumber = true;
                                                                    let showNextChainItemNumber = true;

                                                                    return (
                                                                        <Fragment key={'chain_' + chainId}>
                                                                            <CollapsibleHeadedSection 
                                                                                key={'chain_' + chainId}
                                                                                preHeaderContent={
                                                                                    <FeatureChainHeaderControls
                                                                                        canStart={chatConnected && featureReady && chainUpdateReceived && !featureChainStateObject.active}
                                                                                        canStop={chatConnected && featureReady && chainUpdateReceived && featureChainStateObject.active}
                                                                                        canSkip={chatConnected && featureReady && chainUpdateReceived && featureChainStateObject.active && !featureChainStateObject.looping && (chainSkipAllowed || forceSkipAllowed)}
                                                                                        onStart={() => startChain(chainId)}
                                                                                        onStop={() => stopChain(chainId)}
                                                                                        onSkip={() => {
                                                                                            if (chainSkipAllowed) {
                                                                                                skipChainItem(chainId, featureChainStateObject.index, findFeatureData(featureChainStateObject.chainItems[featureChainStateObject.index].featureId)._id);
                                                                                                return;
                                                                                            }
                                                                                            if (forceSkipAllowed) {
                                                                                                forceChainSkip(chainId, featureChainStateObject.index, findFeatureData(featureChainStateObject.chainItems[featureChainStateObject.index].featureId)._id);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                } 
                                                                                extraHeaderContentRight={
                                                                                    <>
                                                                                        {chatConnected && featureReady && chainUpdateReceived && featureChainStateObject.active && !featureChainStateObject.looping && !chainSkipAllowed && !forceSkipAllowed &&
                                                                                            <div className="small-text light-text">(Moving on...)</div>
                                                                                        }
                                                                                        {chatConnected && featureReady && chainUpdateReceived && featureChainStateObject.active && !featureChainStateObject.looping && !chainSkipAllowed && forceSkipAllowed &&
                                                                                            <div className="small-text light-text">(Click to force next step)</div>
                                                                                        }
                                                                                        {chatConnected && featureReady && chainUpdateReceived && featureChainStateObject.active && featureChainStateObject.looping &&
                                                                                            <div className="small-text light-text">(Looping...)</div>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                title={`#${chainIndex + 1} ${chainIdFeatureData.contentLabel}`} 
                                                                                extraHeaderContentLeft={<span className="small-text light-text no-shrink step-count-label">({getChainStepGroups(chainId, featureChainStateObject.chainItems).length} steps)</span>}
                                                                                id={chainId}
                                                                                onCollapseToggle={onChainToggle}
                                                                                open={expandedChainIds === null ? chainIndex === 0 : expandedChainIds.includes(chainId)}
                                                                            >

                                                                                <div className="fl-column compact standard-rem-top-bot-margin">
                                                                                    {/* FEATURE CHAIN CONTENT */}
                                                                                    {featureChainStateObject && featureChainStateObject.chainItems.length >= 1 && (() => {
                                                                                        const stepGroups = getChainStepGroups(chainId, featureChainStateObject.chainItems);

                                                                                        return stepGroups.map((stepGroup) => {
                                                                                            const stepToggleItemIndex = stepGroup.primaryItemIndex ?? stepGroup.items[0]?.index ?? null;
                                                                                            const stepToggleItem = stepToggleItemIndex !== null ? featureChainStateObject.chainItems?.[stepToggleItemIndex] : null;
                                                                                            const stepEnabled = stepToggleItem?.enabled ?? true;
                                                                                            const currentActiveStepIndex = featureChainStateObject.active
                                                                                                ? featureChainStateObject.chainItems?.[featureChainStateObject.index]?.stepIndex ?? null
                                                                                                : null;
                                                                                            const stepActive = currentActiveStepIndex === stepGroup.stepIndex;

                                                                                            return (
                                                                                                <div className={`feature-chain-step-group${stepActive ? ' is-active' : ''}`} key={`chain_step_${stepGroup.stepIndex}`}>
                                                                                                    <FeatureChainStepHeader
                                                                                                        stepNumber={stepGroup.stepIndex + 1}
                                                                                                        title={stepGroup.title}
                                                                                                        enabled={stepEnabled}
                                                                                                        isActive={stepActive}
                                                                                                        showToggle={stepToggleItemIndex !== null}
                                                                                                        canToggle={chatConnected && stepToggleItemIndex !== null}
                                                                                                        onToggle={() => setChainItemVal(chainId, stepToggleItemIndex, 'enabled', !stepEnabled)}
                                                                                                    />
                                                                                                    <div className="feature-chain-step-items">
                                                                                                        {stepGroup.items.map(({ item, index, isExpandedCopy }) => {
                                                                                                            const featureData = findFeatureData(item.featureId);
                                                                                                            const showInlineExpandedMarker = !isExpandedCopy && stepGroups.some((candidateStepGroup) => (
                                                                                                                candidateStepGroup.stepIndex !== stepGroup.stepIndex &&
                                                                                                                candidateStepGroup.items.some((candidateItem) => candidateItem.index === index && candidateItem.isExpandedCopy)
                                                                                                            ));
                                                                                                            let activeItem = featureChainStateObject.active && featureChainStateObject.index === index;
                                                                                                            if (!activeItem && featureChainStateObject.active && item.endType === CHAINS_HELPER.END_TYPE_IMMEDIATE) {
                                                                                                                for (let i = index + 1; i < featureChainStateObject.chainItems.length; i++) {
                                                                                                                    if (featureChainStateObject.index === i) {
                                                                                                                        activeItem = true;
                                                                                                                        break;
                                                                                                                    }
                                                                                                                    if (featureChainStateObject.chainItems[i].endType === CHAINS_HELPER.END_TYPE_FEATURE_END) {
                                                                                                                        break;
                                                                                                                    }
                                                                                                                }
                                                                                                            }

                                                                                                            if (!featureData) {
                                                                                                                return null;
                                                                                                            }

                                                                                                            return (
                                                                                                                <div className={`feature-chain-item-row${isExpandedCopy ? ' is-expanded-copy' : ''}`} key={`chain_${stepGroup.stepIndex}_${index}`}>
                                                                                                                    {isExpandedCopy &&
                                                                                                                        <div className="feature-chain-expanded-linkage" aria-hidden="true">
                                                                                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.share, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                    <div className="feature-chain-item-body">
                                                                                                                        {getChainedDisruptorPanel(item, featureData, index, chainId, isExpandedCopy, showInlineExpandedMarker)}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    })()}

                                                                                    <div className="fl-row feature-chain-loop-row">
                                                                                        <div className="shrink">
                                                                                            <button
                                                                                                type="button"
                                                                                                className={`feature-chain-loop-toggle${chatConnected && featureReady && featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loop ? ' is-enabled' : ''}`}
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    if (!chatConnected || !featureReady) {
                                                                                                        return;
                                                                                                    }
                                                                                                    setChainItemVal(chainId, featureChainStateObject.chainItems.length - 1, 'loop', !featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loop);
                                                                                                }}
                                                                                                aria-label={featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loop ? 'Disable loop chain' : 'Enable loop chain'}
                                                                                                title={featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loop ? 'Disable loop chain' : 'Enable loop chain'}
                                                                                                disabled={!chatConnected || !featureReady}
                                                                                            >
                                                                                                {IconJsxer.GetIcon(IconJsxer.ICONS.loop, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                                                                            </button>
                                                                                        </div>
                                                                                        <div className="fl-row grow">
                                                                                            <div className="form-field-content label">Loop Chain</div>
                                                                                            {chatConnected && featureReady && featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loop &&
                                                                                                <div className="shrink">
                                                                                                    <HMSTimeField
                                                                                                        id={"loopDelay_" + chainId}
                                                                                                        label="Loop Delay"
                                                                                                        value={featureChainStateObject.chainItems[featureChainStateObject.chainItems.length - 1].loopDelay}
                                                                                                        setFunc={
                                                                                                            (val) => {
                                                                                                                setChainItemVal(chainId, featureChainStateObject.chainItems.length - 1, 'loopDelay', val)
                                                                                                            }
                                                                                                        }
                                                                                                        showHours={false}
                                                                                                        showError={false}
                                                                                                        inlineLabel={true}
                                                                                                    />
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </CollapsibleHeadedSection>
                                                                            <div className="spacer"></div>
                                                                        </Fragment>
                                                                    )
                                                                } else {
                                                                    return null;
                                                                }
                                                            }
                                                        )}

                                                    </div>
                                                </div>
                                            }

                                        </div>

                                        <div className="column no-panel-shadow">
                                            {currentFeature &&
                                            <div className="underlined-panel-heading">
                                                <h4>{`${currentFeature.contentLabel} Controls`}</h4>
                                                <div className="grow"></div>
                                                {!chatConnected &&
                                                    <div className="edit-icon" onClick={() => navigate(TOP_LEVEL_NAV_ROUTES.CUSTOMISE_FEATURE_STREAM.replace(':campaignId', campaignId).replace(':featureId', currentFeature._id).replace(':streamId', streamId))}>
                                                        {IconJsxer.GetIcon(IconJsxer.ICONS.edit, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                                    </div>
                                                }
                                            </div>
                                            }
                                            <div className={`ms-full-scroll-area${!currentFeature ? ' cf-empty-controls' : ''}`}>


                                                <div className="fl-column">

                                                    {!currentFeature &&
                                                        <div className="cf-no-feature-message">
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.error, {height: '2.5rem'})}
                                                            <p>Feature controls will appear here once you select a feature from the campaign flow on the left.</p>
                                                        </div>
                                                    }
                                                    {currentFeature &&
                                                        <FeatureControls
                                                            hideHeading={true}
                                                            feature={currentFeature}
                                                            streamVars={featureVars.current}
                                                            customisationVars={customisationVars.current}
                                                            campaignId={campaignId}
                                                            streamId={streamId}
                                                            featureId={currentFeature._id}
                                                            socket={socketState}
                                                            reportFeatureVarsChangedFunc={reportFeatureVarsChanged}
                                                            saveCustomisationVarsFunc={reportCustomisationVarsChangedAndSave}
                                                            reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                                                            sendFeatureCommandFunc={sendFeatureCommand}
                                                            showTooltipFunc={showTooltip}
                                                            hideTooltipFunc={hideTooltip}
                                                            startCollapsed={false}
                                                            forceCollapsed={false}
                                                            chatConnected={chatConnected}
                                                            featureReady={featureReady}
                                                            key={currentFeature.feature._id}
                                                            isThemeable={getIsFeatureThemable(currentFeature)}
                                                            themeData={themeData}
                                                            applyThemeFunc={applyThemeToFeature}
                                                            openRestrictedCustomisation={openRestrictedCustomisationPopup}
                                                            channels={streamData.channels}
                                                            expeditionDataFetched={expeditionDataFetched}
                                                        />
                                                    }


                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            }

                            {currentTab === 2 &&
                                <>
                                    {streamData &&
                                        <TabDisruptors
                                            _analyticsData={analyticsObj}
                                            _triggerBotPost={triggerBotPost}
                                            _pauseBot={pauseBot}
                                            _unpauseBot={unpauseBot}
                                            _timedBots={timedBots}
                                            _chatConnected={chatConnected}
                                            _featureReady={featureReady}
                                            _streamLiveTime = {streamLiveTime}
                                            _features={campaignContext.campaignData.features}
                                            _featureVars={featureVars}
                                            _customisationVars={customisationVars.current}
                                            _customisationVarsRef={customisationVars}
                                            _reportFeatureVarsChanged={reportFeatureVarsChanged}
                                            _reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                                            _saveCustomisationVarsFunc={reportCustomisationVarsChangedAndSave}
                                            _sendFeatureCommandFunc={sendFeatureCommand}
                                            _showTooltip={showTooltip}
                                            _hideTooltip={hideTooltip}

                                            _currentDisruptor={currentFeature}
                                            _setCurrentDisruptor={changeFeature}
                                            _previewMode={previewMode}
                                            _setPreviewMode={togglePreviewMode}

                                            _postMessageToPreviewFrame={postMessageToPreviewFrame}

                                            _campaignId={campaignId}
                                            _streamId={streamId}
                                            _allQuizData={quizData_ref.current}

                                            _liveStreamServerState={liveStreamServerState || {}}
                                            _toggleChatCommandEnabled={toggleChatCommandEnabled}

                                            _themeData={themeData}
                                            _applyThemeFunc={applyThemeToFeature}
                                            openRestrictedCustomisation={openRestrictedCustomisationPopup}

                                            channels={streamData.channels}
                                            expeditionDataFetched={expeditionDataFetched}
                                            socket={socketState}
                                        />
                                    }
                                </>
                            }

                            {currentTab === 3 &&
                                <>
                                    {streamData &&
                                        <TabBots
                                            _analyticsData={analyticsObj}
                                            _triggerBotPost={triggerBotPost}
                                            _pauseBot={pauseBot}
                                            _unpauseBot={unpauseBot}
                                            _timedBots={timedBots}
                                            _streamStarted={streamStarted}
                                            _streamLiveTime = {streamLiveTime}
                                            _features={campaignContext.campaignData.features}
                                            _featureVars={featureVars}
                                            _reportFeatureVarsChanged={reportFeatureVarsChanged}
                                            _reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                                            _sendFeatureCommandFunc={sendFeatureCommand}
                                            _showTooltip={showTooltip}
                                            _hideTooltip={hideTooltip}
                                            _botsAvailable={chatConnected && botAuthorised}
                                        />
                                    }
                                </>
                            }
                            {currentTab === 4 &&
                                <>
                                    {streamData &&
                                        <TabAnalytics
                                            _analyticsAvilable={analyticsAvailable.current}
                                            _connected={chatConnected}
                                            _analyticsData={analyticsObj}
                                            _updateAnalyticsFunc = {setAnalyticsObj}
                                            _streamID={streamId}
                                            _streamData={streamData}
                                            _triggerBotPost={triggerBotPost}
                                            _pauseBot={pauseBot}
                                            _unpauseBot={unpauseBot}
                                            _timedBots={timedBots}
                                            _streamLiveTime = {streamLiveTime}
                                            _features={campaignContext.campaignData.features}
                                            _featureVars={featureVars}
                                            _reportFeatureVarsChanged={reportFeatureVarsChanged}
                                            _reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                                            _sendFeatureCommandFunc={sendFeatureCommand}
                                            _showTooltip={showTooltip}
                                            _hideTooltip={hideTooltip}
                                        />
                                    }
                                </>
                            }
                            </div>
                        </TabbedPanel>
                    </div>


                    {/* <h1 className="mt-4 mb-2">Welcome to the Manage Stream page</h1>

                    <p><a href='' onClick={(e) => { activateChat(e) }}>ACTIVATE CHAT</a></p>
                    <p><a href='' onClick={(e) => { sendChatMsg(e, 'Just a little test message') }}>Send Test Message</a></p>

                    {campaignContext.initialising &&
                        <p className="label">Fetching Campaign Data</p>
                    }

                    {!campaignContext.initialising &&
                        <>

               
                            <p className="label">Campaign ID: {campaignId}</p>
                            <p className="label">Stream ID: {streamId}</p>
                            
                            <p>Unique Users: {analyticsObj.userList && <>{analyticsObj.userList.length}</>}</p>
                            <p>Top User: {analyticsObj.userList && analyticsObj.userList.length  > 0 && <>{analyticsObj.userList[0].username} - {analyticsObj.userList[0].amount}</>}</p>
                           
                            <h4>Raw campaign data:</h4>
                            {Object.entries(campaignContext.campaignData).map(
                                ([k, v], i) => <p key={k}>{k + ': ' + v}</p>
                            )}
                            <h4>Raw stream data:</h4>
                            {streamData && Object.entries(streamData).map(
                                ([k, v], i) => <p key={k}>{k + ': ' + v}</p>
                            )}
                        </>
                    } 
                    
                      <h4>Raw analytics data:</h4>
                            {Object.entries(analyticsObj).map(
                                ([k, v], i) => <p key={k}>{k + ': ' + v}</p>
                            )}
                    */}

                   

                </div>
            </div>
            {showingTooltip &&
                <div className="tw-tooltip" style={tooltipPos} dangerouslySetInnerHTML={{__html: tooltipText}}>
                </div>
            }
            {/* <ControlBar connected={chatConnected} demoMode={demoMode} setDemoMode={setDemoMode} connectFunc={activateChat} disconnectFunc={endStream} /> */}
            {/*chatConnected &&*/
                <ChatTranscript chatHistory={chatHistory} channels={streamData ?streamData.channels  : null} />
            }
            {previewMode &&
                <FeaturePreview
                    campaignId={campaignId}

                    currentFeature={currentFeature}
                    featureVars={featureVars}
                    streamId={streamId}
                    customisationVars={customisationVars.current}
                    titlePostFix={previewTitlePostFix}
                    onLoad={() => setPreviewLoaded(true)}
                    closeFunc={() => togglePreviewMode(false)}

                    startControlsExpanded={currentTab === 1 || currentFeature.feature.featureType === 'feature'}
                    startMaximized={currentTab === 1 || currentFeature.feature.featureType === 'feature'}

                    _reportFeatureVarsChanged={reportFeatureVarsChanged}
                    _reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                    _sendFeatureCommandFunc={sendFeatureCommand}
                    _showTooltip={showTooltip}
                    _hideTooltip={hideTooltip}
                />
            }
            {showWizard && streamData && streamData.status !== 'ended' &&
                <StartupWizard 
                    closePanelFunc={closeWizard} 
                    streamLink={window.location.origin +'/obs-feature/'+campaignId+'/'+streamId+'/321ABC'}
                    featureReady={featureReady}
                    audioEnabled={audioEnabled}
                    setOverlayState={setOverlayState}
                    chatConnected={chatConnected}
                    botAuthorised={botAuthorised}
                    activateChat={activateChat}
                    showInvitePanel={showInvitePanel}
                    invitePanelOpen={showInviteUserPanel}
                    connectingPanelOpen={connecting}
                    streamerExists={streamerExists}
                />
            }
            {showInviteUserPanel &&
                <TabbedInviteUser closePanelFunc={closeInviteUserPanel} campaignId={campaignId} hideExisting={true} showAcTypeSelector={false} acType={ACCOUNT_TYPES.streamer} acTypeFilter={[ACCOUNT_TYPES.streamer]} defaultTab={0} />
            }
            {connecting &&
                <ConnectingPopup stream={streamData} activationObj={activationObj}/>
            }
            {showForceStopPopup &&
                <ForceStopPopup closePanelFunc={closeForceStopPopup} forceStopNow={forceStopNow} />
            }
            {showRatingPopup &&
                <RateStreamPopup closePanelFunc={closeRatingPopup} campaignId={campaignId} streamId={streamId} rating={getCurrentRating()} />
            }
            {showingKillOldFeaturesPopup &&
                <KillFeaturesPopup closePanelFunc={() => setShowingKillOldFeaturesPopup(false)} killOldFeaturePages={killOldFeaturePages} activatedFeatures={activatedFeatures} />
            }
            {showingRestrictedCustomisationPopup &&
                <RestrictedCustomisationPopup
                    title={restrictedCustomisationTitle.current}
                    tab={restrictedCustomisationTab.current}
                    group={restrictedCustomisationGroup.current}
                    family={restrictedCustomisationFamily.current}
                    closePanelFunc={closeRestrictedCustomisationPopup}
                    featureId={restrictedCustomisationFeatureId.current}
                    campaignId={campaignId}
                    campaignData={campaignData_ref.current}
                    customisationVars={customisationVars.current}
                    saveCustomisationVars={reportCustomisationVarsChangedAndSave}
                />
            }
            {/* TopBar dropdown panels */}
            <StreamsDropdown
                isOpen={showStreamsDropdown}
                onClose={() => setShowStreamsDropdown(false)}
                campaignId={campaignId}
                onAddStream={() => navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW_TAB.replace(':id', campaignId).replace(':tab', 'streams'))}
                onEditStream={() => navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGN_OVERVIEW_TAB.replace(':id', campaignId).replace(':tab', 'streams'))}
            />
            <AnalyticsDropdown
                isOpen={showAnalyticsDropdown}
                onClose={() => setShowAnalyticsDropdown(false)}
                openSessionAnalytics={null}
            />
            {showTopBarInvitePanel &&
                <TabbedInviteUser closePanelFunc={() => setShowTopBarInvitePanel(false)} campaignId={campaignId} showAcTypeSelector={true} />
            }
        </div>
    );
}

export default ManageStream;
